const states = {
    US: [
        {
            name: 'Armed Forces (AA)',
            value: 'AA',
        },
        {
            name: 'Armed Forces (AP)',
            value: 'AP',
        },
        {
            name: 'Armed Forces (AE)',
            value: 'AE',
        },
        { value: 'AK', name: 'Alaska' },
        { value: 'AS', name: 'American Samoa' },
        { value: 'AL', name: 'Alabama' },
        { value: 'AR', name: 'Arkansas' },
        { value: 'AZ', name: 'Arizona' },
        { value: 'CA', name: 'California' },
        { value: 'CO', name: 'Colorado' },
        { value: 'CT', name: 'Connecticut' },
        { value: 'DC', name: 'District of Columbia' },
        { value: 'DE', name: 'Delaware' },
        { value: 'FL', name: 'Florida' },
        { value: 'GA', name: 'Georgia' },
        { value: 'GU', name: 'Guam' },
        { value: 'HI', name: 'Hawaii' },
        { value: 'IA', name: 'Iowa' },
        { value: 'ID', name: 'Idaho' },
        { value: 'IL', name: 'Illinois' },
        { value: 'IN', name: 'Indiana' },
        { value: 'KS', name: 'Kansas' },
        { value: 'KY', name: 'Kentucky' },
        { value: 'LA', name: 'Louisiana' },
        { value: 'MP', name: 'Northern Mariana Islands' },
        { value: 'MH', name: 'Marshall Islands' },
        { value: 'MA', name: 'Massachusetts' },
        { value: 'MD', name: 'Maryland' },
        { value: 'ME', name: 'Maine' },
        { value: 'MI', name: 'Michigan' },
        { value: 'MN', name: 'Minnesota' },
        { value: 'MO', name: 'Missouri' },
        { value: 'MS', name: 'Mississippi' },
        { value: 'MT', name: 'Montana' },
        { value: 'FM', name: 'Federated States of Micronesia' },
        { value: 'NC', name: 'North Carolina' },
        { value: 'ND', name: 'North Dakota' },
        { value: 'NE', name: 'Nebraska' },
        { value: 'NH', name: 'New Hampshire' },
        { value: 'NJ', name: 'New Jersey' },
        { value: 'NM', name: 'New Mexico' },
        { value: 'NV', name: 'Nevada' },
        { value: 'NY', name: 'New York' },
        { value: 'OH', name: 'Ohio' },
        { value: 'OK', name: 'Oklahoma' },
        { value: 'OR', name: 'Oregon' },
        { value: 'PW', name: 'Palau' },
        { value: 'PA', name: 'Pennsylvania' },
        { value: 'PR', name: 'Puerto Rico' },
        { value: 'RI', name: 'Rhode Island' },
        { value: 'SC', name: 'South Carolina' },
        { value: 'SD', name: 'South Dakota' },
        { value: 'TN', name: 'Tennessee' },
        { value: 'TX', name: 'Texas' },
        { value: 'UT', name: 'Utah' },
        { value: 'UM', name: 'United States Minor Outlying Islands' },
        { value: 'VA', name: 'Virginia' },
        { value: 'VI', name: 'Virgin Islands, U.S.' },
        { value: 'VT', name: 'Vermont' },
        { value: 'WA', name: 'Washington' },
        { value: 'WI', name: 'Wisconsin' },
        { value: 'WV', name: 'West Virginia' },
        { value: 'WY', name: 'Wyoming' },
    ],
    CA: [
        { value: 'AB', name: 'Alberta' },
        { value: 'BC', name: 'British Columbia' },
        { value: 'MB', name: 'Manitoba' },
        { value: 'NB', name: 'New Brunswick' },
        { value: 'NL', name: 'Newfoundland' },
        { value: 'NT', name: 'Northwest Territories' },
        { value: 'NS', name: 'Nova Scotia' },
        { value: 'NU', name: 'Nunavut' },
        { value: 'ON', name: 'Ontario' },
        { value: 'PE', name: 'Prince Edward Island' },
        { value: 'QC', name: 'Quebec' },
        { value: 'SK', name: 'Saskatchewan' },
        { value: 'YT', name: 'Yukon' },
    ],
}
export default states

// Expanded list of states used in every RegionSelect input across application
export const regionSelectStates = {
    ...states,
    AL: [
        { value: 'Berat', name: 'Berat' },
        { value: 'Dibres', name: 'Dibres' },
        { value: 'Durres', name: 'Durres' },
        { value: 'Elbasan', name: 'Elbasan' },
        { value: 'Fier', name: 'Fier' },
        { value: 'Gjirokastre', name: 'Gjirokastre' },
        { value: 'Korce', name: 'Korce' },
        { value: 'Kukes', name: 'Kukes' },
        { value: 'Lezhe', name: 'Lezhe' },
        { value: 'Shkoder', name: 'Shkoder' },
        { value: 'Tirane', name: 'Tirane' },
        { value: 'Vlore', name: 'Vlore' },
    ],
    DZ: [
        { value: 'Adrar', name: 'Adrar' },
        { value: 'Ain Defla', name: 'Ain Defla' },
        { value: 'Ain Temouchent', name: 'Ain Temouchent' },
        { value: 'Alger', name: 'Alger' },
        { value: 'Annaba', name: 'Annaba' },
        { value: 'Batna', name: 'Batna' },
        { value: 'Bechar', name: 'Bechar' },
        { value: 'Bejaia', name: 'Bejaia' },
        { value: 'Biskra', name: 'Biskra' },
        { value: 'Blida', name: 'Blida' },
        { value: 'Bordj Bou Arreridj', name: 'Bordj Bou Arreridj' },
        { value: 'Bouira', name: 'Bouira' },
        { value: 'Boumerdes', name: 'Boumerdes' },
        { value: 'Chlef', name: 'Chlef' },
        { value: 'Constantine', name: 'Constantine' },
        { value: 'Djelfa', name: 'Djelfa' },
        { value: 'El Bayadh', name: 'El Bayadh' },
        { value: 'El Oued', name: 'El Oued' },
        { value: 'El Tarf', name: 'El Tarf' },
        { value: 'Ghardaia', name: 'Ghardaia' },
        { value: 'Guelma', name: 'Guelma' },
        { value: 'Illizi', name: 'Illizi' },
        { value: 'Jijel', name: 'Jijel' },
        { value: 'Khenchela', name: 'Khenchela' },
        { value: 'Laghouat', name: 'Laghouat' },
        { value: 'Muaskar', name: 'Muaskar' },
        { value: 'Medea', name: 'Medea' },
        { value: 'Mila', name: 'Mila' },
        { value: 'Mostaganem', name: 'Mostaganem' },
        { value: "M'Sila", name: "M'Sila" },
        { value: 'Naama', name: 'Naama' },
        { value: 'Oran', name: 'Oran' },
        { value: 'Ouargla', name: 'Ouargla' },
        { value: 'Oum el Bouaghi', name: 'Oum el Bouaghi' },
        { value: 'Relizane', name: 'Relizane' },
        { value: 'Saida', name: 'Saida' },
        { value: 'Setif', name: 'Setif' },
        { value: 'Sidi Bel Abbes', name: 'Sidi Bel Abbes' },
        { value: 'Skikda', name: 'Skikda' },
        { value: 'Souk Ahras', name: 'Souk Ahras' },
        { value: 'Tamanghasset', name: 'Tamanghasset' },
        { value: 'Tebessa', name: 'Tebessa' },
        { value: 'Tiaret', name: 'Tiaret' },
        { value: 'Tindouf', name: 'Tindouf' },
        { value: 'Tipaza', name: 'Tipaza' },
        { value: 'Tissemsilt', name: 'Tissemsilt' },
        { value: 'Tizi Ouzou', name: 'Tizi Ouzou' },
        { value: 'Tlemcen', name: 'Tlemcen' },
    ],
    AD: [
        { value: 'Andorra la Vella', name: 'Andorra la Vella' },
        { value: 'Canillo', name: 'Canillo' },
        { value: 'Encamp', name: 'Encamp' },
        { value: 'Escaldes-Engordany', name: 'Escaldes-Engordany' },
        { value: 'La Massana', name: 'La Massana' },
        { value: 'Ordino', name: 'Ordino' },
        { value: 'Sant Julia de Loria', name: 'Sant Julia de Loria' },
    ],
    AO: [
        { value: 'Bengo', name: 'Bengo' },
        { value: 'Benguela', name: 'Benguela' },
        { value: 'Bie', name: 'Bie' },
        { value: 'Cabinda', name: 'Cabinda' },
        { value: 'Cuando Cubango', name: 'Cuando Cubango' },
        { value: 'Cuanza Norte', name: 'Cuanza Norte' },
        { value: 'Cuanza Sul', name: 'Cuanza Sul' },
        { value: 'Cunene', name: 'Cunene' },
        { value: 'Huambo', name: 'Huambo' },
        { value: 'Huila', name: 'Huila' },
        { value: 'Luanda', name: 'Luanda' },
        { value: 'Lunda Norte', name: 'Lunda Norte' },
        { value: 'Lunda Sul', name: 'Lunda Sul' },
        { value: 'Malanje', name: 'Malanje' },
        { value: 'Moxico', name: 'Moxico' },
        { value: 'Namibe', name: 'Namibe' },
        { value: 'Uige', name: 'Uige' },
        { value: 'Zaire', name: 'Zaire' },
    ],
    AG: [
        { value: 'Barbuda', name: 'Barbuda' },
        { value: 'Redonda', name: 'Redonda' },
        { value: 'Saint George', name: 'Saint George' },
        { value: 'Saint John', name: 'Saint John' },
        { value: 'Saint Mary', name: 'Saint Mary' },
        { value: 'Saint Paul', name: 'Saint Paul' },
        { value: 'Saint Peter', name: 'Saint Peter' },
        { value: 'Saint Philip', name: 'Saint Philip' },
    ],
    AR: [
        { value: 'Buenos Aires', name: 'Buenos Aires' },
        { value: 'Buenos Aires Capital', name: 'Buenos Aires Capital' },
        { value: 'Catamarca', name: 'Catamarca' },
        { value: 'Chaco', name: 'Chaco' },
        { value: 'Chubut', name: 'Chubut' },
        { value: 'Cordoba', name: 'Cordoba' },
        { value: 'Corrientes', name: 'Corrientes' },
        { value: 'Entre Rios', name: 'Entre Rios' },
        { value: 'Formosa', name: 'Formosa' },
        { value: 'Jujuy', name: 'Jujuy' },
        { value: 'La Pampa', name: 'La Pampa' },
        { value: 'La Rioja', name: 'La Rioja' },
        { value: 'Mendoza', name: 'Mendoza' },
        { value: 'Misiones', name: 'Misiones' },
        { value: 'Neuquen', name: 'Neuquen' },
        { value: 'Rio Negro', name: 'Rio Negro' },
        { value: 'Salta', name: 'Salta' },
        { value: 'San Juan', name: 'San Juan' },
        { value: 'San Luis', name: 'San Luis' },
        { value: 'Santa Cruz', name: 'Santa Cruz' },
        { value: 'Santa Fe', name: 'Santa Fe' },
        { value: 'Santiago del Estero', name: 'Santiago del Estero' },
        { value: 'Tierra del Fuego', name: 'Tierra del Fuego' },
        { value: 'Tucuman', name: 'Tucuman' },
    ],
    AM: [
        { value: 'Aragatsotn', name: 'Aragatsotn' },
        { value: 'Ararat', name: 'Ararat' },
        { value: 'Armavir', name: 'Armavir' },
        { value: "Geghark'unik'", name: "Geghark'unik'" },
        { value: "Kotayk'", name: "Kotayk'" },
        { value: 'Lorri', name: 'Lorri' },
        { value: 'Shirak', name: 'Shirak' },
        { value: "Syunik'", name: "Syunik'" },
        { value: 'Tavush', name: 'Tavush' },
        { value: "Vayots' Dzor", name: "Vayots' Dzor" },
        { value: 'Yerevan', name: 'Yerevan' },
    ],
    AU: [
        { value: 'New South Wales', name: 'New South Wales' },
        { value: 'Northern Territory', name: 'Northern Territory' },
        { value: 'Queensland', name: 'Queensland' },
        { value: 'South Australia', name: 'South Australia' },
        { value: 'Tasmania', name: 'Tasmania' },
        { value: 'Victoria', name: 'Victoria' },
        { value: 'Western Australia', name: 'Western Australia' },
    ],
    AT: [
        { value: 'Burgenland', name: 'Burgenland' },
        { value: 'Kaernten', name: 'Kaernten' },
        { value: 'Niederoesterreich', name: 'Niederoesterreich' },
        { value: 'Oberoesterreich', name: 'Oberoesterreich' },
        { value: 'Salzburg', name: 'Salzburg' },
        { value: 'Steiermark', name: 'Steiermark' },
        { value: 'Tirol', name: 'Tirol' },
        { value: 'Vorarlberg', name: 'Vorarlberg' },
        { value: 'Wien', name: 'Wien' },
    ],
    AZ: [
        { value: 'Abseron Rayonu', name: 'Abseron Rayonu' },
        { value: 'Agcabadi Rayonu', name: 'Agcabadi Rayonu' },
        { value: 'Agdam Rayonu', name: 'Agdam Rayonu' },
        { value: 'Agdas Rayonu', name: 'Agdas Rayonu' },
        { value: 'Agstafa Rayonu', name: 'Agstafa Rayonu' },
        { value: 'Agsu Rayonu', name: 'Agsu Rayonu' },
        { value: 'Astara Rayonu', name: 'Astara Rayonu' },
        { value: 'Balakan Rayonu', name: 'Balakan Rayonu' },
        { value: 'Barda Rayonu', name: 'Barda Rayonu' },
        { value: 'Beylaqan Rayonu', name: 'Beylaqan Rayonu' },
        { value: 'Bilasuvar Rayonu', name: 'Bilasuvar Rayonu' },
        { value: 'Cabrayil Rayonu', name: 'Cabrayil Rayonu' },
        { value: 'Calilabad Rayonu', name: 'Calilabad Rayonu' },
        { value: 'Daskasan Rayonu', name: 'Daskasan Rayonu' },
        { value: 'Davaci Rayonu', name: 'Davaci Rayonu' },
        { value: 'Fuzuli Rayonu', name: 'Fuzuli Rayonu' },
        { value: 'Gadabay Rayonu', name: 'Gadabay Rayonu' },
        { value: 'Goranboy Rayonu', name: 'Goranboy Rayonu' },
        { value: 'Goycay Rayonu', name: 'Goycay Rayonu' },
        { value: 'Haciqabul Rayonu', name: 'Haciqabul Rayonu' },
        { value: 'Imisli Rayonu', name: 'Imisli Rayonu' },
        { value: 'Ismayilli Rayonu', name: 'Ismayilli Rayonu' },
        { value: 'Kalbacar Rayonu', name: 'Kalbacar Rayonu' },
        { value: 'Kurdamir Rayonu', name: 'Kurdamir Rayonu' },
        { value: 'Lacin Rayonu', name: 'Lacin Rayonu' },
        { value: 'Lankaran Rayonu', name: 'Lankaran Rayonu' },
        { value: 'Lerik Rayonu', name: 'Lerik Rayonu' },
        { value: 'Masalli Rayonu', name: 'Masalli Rayonu' },
        { value: 'Neftcala Rayonu', name: 'Neftcala Rayonu' },
        { value: 'Oguz Rayonu', name: 'Oguz Rayonu' },
        { value: 'Qabala Rayonu', name: 'Qabala Rayonu' },
        { value: 'Qax Rayonu', name: 'Qax Rayonu' },
        { value: 'Qazax Rayonu', name: 'Qazax Rayonu' },
        { value: 'Qobustan Rayonu', name: 'Qobustan Rayonu' },
        { value: 'Quba Rayonu', name: 'Quba Rayonu' },
        { value: 'Qubadli Rayonu', name: 'Qubadli Rayonu' },
        { value: 'Qusar Rayonu', name: 'Qusar Rayonu' },
        { value: 'Saatli Rayonu', name: 'Saatli Rayonu' },
        { value: 'Sabirabad Rayonu', name: 'Sabirabad Rayonu' },
        { value: 'Saki Rayonu', name: 'Saki Rayonu' },
        { value: 'Salyan Rayonu', name: 'Salyan Rayonu' },
        { value: 'Samaxi Rayonu', name: 'Samaxi Rayonu' },
        { value: 'Samkir Rayonu', name: 'Samkir Rayonu' },
        { value: 'Samux Rayonu', name: 'Samux Rayonu' },
        { value: 'Siyazan Rayonu', name: 'Siyazan Rayonu' },
        { value: 'Susa Rayonu', name: 'Susa Rayonu' },
        { value: 'Tartar Rayonu', name: 'Tartar Rayonu' },
        { value: 'Tovuz Rayonu', name: 'Tovuz Rayonu' },
        { value: 'Ucar Rayonu', name: 'Ucar Rayonu' },
        { value: 'Xacmaz Rayonu', name: 'Xacmaz Rayonu' },
        { value: 'Xanlar Rayonu', name: 'Xanlar Rayonu' },
        { value: 'Xizi Rayonu', name: 'Xizi Rayonu' },
        { value: 'Xocali Rayonu', name: 'Xocali Rayonu' },
        { value: 'Xocavand Rayonu', name: 'Xocavand Rayonu' },
        { value: 'Yardimli Rayonu', name: 'Yardimli Rayonu' },
        { value: 'Yevlax Rayonu', name: 'Yevlax Rayonu' },
        { value: 'Zangilan Rayonu', name: 'Zangilan Rayonu' },
        { value: 'Zaqatala Rayonu', name: 'Zaqatala Rayonu' },
        { value: 'Zardab Rayonu', name: 'Zardab Rayonu' },
        { value: 'Ali Bayramli Sahari', name: 'Ali Bayramli Sahari' },
        { value: 'Baki Sahari', name: 'Baki Sahari' },
        { value: 'Ganca Sahari', name: 'Ganca Sahari' },
        { value: 'Lankaran Sahari', name: 'Lankaran Sahari' },
        { value: 'Mingacevir Sahari', name: 'Mingacevir Sahari' },
        { value: 'Naftalan Sahari', name: 'Naftalan Sahari' },
        { value: 'Saki Sahari', name: 'Saki Sahari' },
        { value: 'Sumqayit Sahari', name: 'Sumqayit Sahari' },
        { value: 'Susa Sahari', name: 'Susa Sahari' },
        { value: 'Xankandi Sahari', name: 'Xankandi Sahari' },
        { value: 'Yevlax Sahari', name: 'Yevlax Sahari' },
        { value: 'Naxcivan Muxtar', name: 'Naxcivan Muxtar' },
    ],
    BS: [
        { value: 'Acklins and Crooked Islands', name: 'Acklins and Crooked Islands' },
        { value: 'Bimini', name: 'Bimini' },
        { value: 'Cat Island', name: 'Cat Island' },
        { value: 'Exuma', name: 'Exuma' },
        { value: 'Freeport', name: 'Freeport' },
        { value: 'Fresh Creek', name: 'Fresh Creek' },
        { value: "Governor's Harbour", name: "Governor's Harbour" },
        { value: 'Green Turtle Cay', name: 'Green Turtle Cay' },
        { value: 'Harbour Island', name: 'Harbour Island' },
        { value: 'High Rock', name: 'High Rock' },
        { value: 'Inagua', name: 'Inagua' },
        { value: 'Kemps Bay', name: 'Kemps Bay' },
        { value: 'Long Island', name: 'Long Island' },
        { value: 'Marsh Harbour', name: 'Marsh Harbour' },
        { value: 'Mayaguana', name: 'Mayaguana' },
        { value: 'New Providence', name: 'New Providence' },
        { value: 'Nichollstown and Berry Islands', name: 'Nichollstown and Berry Islands' },
        { value: 'Ragged Island', name: 'Ragged Island' },
        { value: 'Rock Sound', name: 'Rock Sound' },
        { value: 'Sandy Point', name: 'Sandy Point' },
        { value: 'San Salvador and Rum Cay', name: 'San Salvador and Rum Cay' },
    ],
    BH: [
        { value: 'Al Hadd', name: 'Al Hadd' },
        { value: 'Al Manamah', name: 'Al Manamah' },
        { value: 'Al Mintaqah al Gharbiyah', name: 'Al Mintaqah al Gharbiyah' },
        { value: 'Al Mintaqah al Wusta', name: 'Al Mintaqah al Wusta' },
        { value: 'Al Mintaqah ash Shamaliyah', name: 'Al Mintaqah ash Shamaliyah' },
        { value: 'Al Muharraq', name: 'Al Muharraq' },
        {
            value: "Ar Rifa' wa al Mintaqah al Janubiyah",
            name: "Ar Rifa' wa al Mintaqah al Janubiyah",
        },
        { value: 'Jidd Hafs', name: 'Jidd Hafs' },
        { value: 'Madinat Hamad', name: 'Madinat Hamad' },
        { value: "Madinat 'Isa", name: "Madinat 'Isa" },
        { value: 'Juzur Hawar', name: 'Juzur Hawar' },
        { value: 'Sitrah', name: 'Sitrah' },
    ],
    BD: [
        { value: 'Barisal', name: 'Barisal' },
        { value: 'Chittagong', name: 'Chittagong' },
        { value: 'Dhaka', name: 'Dhaka' },
        { value: 'Khulna', name: 'Khulna' },
        { value: 'Rajshahi', name: 'Rajshahi' },
        { value: 'Sylhet', name: 'Sylhet' },
    ],
    BB: [
        { value: 'Christ Church', name: 'Christ Church' },
        { value: 'Saint Andrew', name: 'Saint Andrew' },
        { value: 'Saint George', name: 'Saint George' },
        { value: 'Saint James', name: 'Saint James' },
        { value: 'Saint John', name: 'Saint John' },
        { value: 'Saint Joseph', name: 'Saint Joseph' },
        { value: 'Saint Lucy', name: 'Saint Lucy' },
        { value: 'Saint Michael', name: 'Saint Michael' },
        { value: 'Saint Peter', name: 'Saint Peter' },
        { value: 'Saint Philip', name: 'Saint Philip' },
        { value: 'Saint Thomas', name: 'Saint Thomas' },
    ],
    BY: [
        { value: 'Brest', name: 'Brest' },
        { value: 'Homyel', name: 'Homyel' },
        { value: 'Horad Minsk', name: 'Horad Minsk' },
        { value: 'Hrodna', name: 'Hrodna' },
        { value: 'Mahilyow', name: 'Mahilyow' },
        { value: 'Minsk', name: 'Minsk' },
        { value: 'Vitsyebsk', name: 'Vitsyebsk' },
    ],
    BE: [
        { value: 'Antwerpen', name: 'Antwerpen' },
        { value: 'Brabant Wallon', name: 'Brabant Wallon' },
        { value: 'Brussels', name: 'Brussels' },
        { value: 'Flanders', name: 'Flanders' },
        { value: 'Hainaut', name: 'Hainaut' },
        { value: 'Liege', name: 'Liege' },
        { value: 'Limburg', name: 'Limburg' },
        { value: 'Luxembourg', name: 'Luxembourg' },
        { value: 'Namur', name: 'Namur' },
        { value: 'Oost-Vlaanderen', name: 'Oost-Vlaanderen' },
        { value: 'Vlaams-Brabant', name: 'Vlaams-Brabant' },
        { value: 'Wallonia', name: 'Wallonia' },
        { value: 'West-Vlaanderen', name: 'West-Vlaanderen' },
    ],
    BZ: [
        { value: 'Belize', name: 'Belize' },
        { value: 'Cayo', name: 'Cayo' },
        { value: 'Corozal', name: 'Corozal' },
        { value: 'Orange Walk', name: 'Orange Walk' },
        { value: 'Stann Creek', name: 'Stann Creek' },
        { value: 'Toledo', name: 'Toledo' },
    ],
    BJ: [
        { value: 'Alibori', name: 'Alibori' },
        { value: 'Atakora', name: 'Atakora' },
        { value: 'Atlantique', name: 'Atlantique' },
        { value: 'Borgou', name: 'Borgou' },
        { value: 'Collines', name: 'Collines' },
        { value: 'Donga', name: 'Donga' },
        { value: 'Kouffo', name: 'Kouffo' },
        { value: 'Littoral', name: 'Littoral' },
        { value: 'Mono', name: 'Mono' },
        { value: 'Oueme', name: 'Oueme' },
        { value: 'Plateau', name: 'Plateau' },
        { value: 'Zou', name: 'Zou' },
    ],
    BT: [
        { value: 'Bumthang', name: 'Bumthang' },
        { value: 'Chukha', name: 'Chukha' },
        { value: 'Dagana', name: 'Dagana' },
        { value: 'Gasa', name: 'Gasa' },
        { value: 'Haa', name: 'Haa' },
        { value: 'Lhuntse', name: 'Lhuntse' },
        { value: 'Mongar', name: 'Mongar' },
        { value: 'Paro', name: 'Paro' },
        { value: 'Pemagatshel', name: 'Pemagatshel' },
        { value: 'Punakha', name: 'Punakha' },
        { value: 'Samdrup Jongkhar', name: 'Samdrup Jongkhar' },
        { value: 'Samtse', name: 'Samtse' },
        { value: 'Sarpang', name: 'Sarpang' },
        { value: 'Thimphu', name: 'Thimphu' },
        { value: 'Trashigang', name: 'Trashigang' },
        { value: 'Trashiyangste', name: 'Trashiyangste' },
        { value: 'Trongsa', name: 'Trongsa' },
        { value: 'Tsirang', name: 'Tsirang' },
        { value: 'Wangdue Phodrang', name: 'Wangdue Phodrang' },
        { value: 'Zhemgang', name: 'Zhemgang' },
    ],
    BO: [
        { value: 'Chuquisaca', name: 'Chuquisaca' },
        { value: 'Cochabamba', name: 'Cochabamba' },
        { value: 'Beni', name: 'Beni' },
        { value: 'La Paz', name: 'La Paz' },
        { value: 'Oruro', name: 'Oruro' },
        { value: 'Pando', name: 'Pando' },
        { value: 'Potosi', name: 'Potosi' },
        { value: 'Santa Cruz', name: 'Santa Cruz' },
        { value: 'Tarija', name: 'Tarija' },
    ],
    BA: [
        { value: 'Una-Sana [Federation]', name: 'Una-Sana [Federation]' },
        { value: 'Posavina [Federation]', name: 'Posavina [Federation]' },
        { value: 'Tuzla [Federation]', name: 'Tuzla [Federation]' },
        { value: 'Zenica-Doboj [Federation]', name: 'Zenica-Doboj [Federation]' },
        { value: 'Bosnian Podrinje [Federation]', name: 'Bosnian Podrinje [Federation]' },
        { value: 'Central Bosnia [Federation]', name: 'Central Bosnia [Federation]' },
        { value: 'Herzegovina-Neretva [Federation]', name: 'Herzegovina-Neretva [Federation]' },
        { value: 'West Herzegovina [Federation]', name: 'West Herzegovina [Federation]' },
        { value: 'Sarajevo [Federation]', name: 'Sarajevo [Federation]' },
        { value: ' West Bosnia [Federation]', name: ' West Bosnia [Federation]' },
        { value: 'Banja Luka [RS]', name: 'Banja Luka [RS]' },
        { value: 'Bijeljina [RS]', name: 'Bijeljina [RS]' },
        { value: 'Doboj [RS]', name: 'Doboj [RS]' },
        { value: 'Fo?a [RS]', name: 'Fo?a [RS]' },
        { value: 'Sarajevo-Romanija [RS]', name: 'Sarajevo-Romanija [RS]' },
        { value: 'Trebinje [RS]', name: 'Trebinje [RS]' },
        { value: 'Vlasenica [RS]', name: 'Vlasenica [RS]' },
    ],
    BW: [
        { value: 'Central', name: 'Central' },
        { value: 'Ghanzi', name: 'Ghanzi' },
        { value: 'Kgalagadi', name: 'Kgalagadi' },
        { value: 'Kgatleng', name: 'Kgatleng' },
        { value: 'Kweneng', name: 'Kweneng' },
        { value: 'North East', name: 'North East' },
        { value: 'North West', name: 'North West' },
        { value: 'South East', name: 'South East' },
        { value: 'Southern', name: 'Southern' },
    ],
    BR: [
        { value: 'Acre', name: 'Acre' },
        { value: 'Alagoas', name: 'Alagoas' },
        { value: 'Amapa', name: 'Amapa' },
        { value: 'Amazonas', name: 'Amazonas' },
        { value: 'Bahia', name: 'Bahia' },
        { value: 'Ceara', name: 'Ceara' },
        { value: 'Distrito Federal', name: 'Distrito Federal' },
        { value: 'Espirito Santo', name: 'Espirito Santo' },
        { value: 'Goias', name: 'Goias' },
        { value: 'Maranhao', name: 'Maranhao' },
        { value: 'Mato Grosso', name: 'Mato Grosso' },
        { value: 'Mato Grosso do Sul', name: 'Mato Grosso do Sul' },
        { value: 'Minas Gerais', name: 'Minas Gerais' },
        { value: 'Para', name: 'Para' },
        { value: 'Paraiba', name: 'Paraiba' },
        { value: 'Parana', name: 'Parana' },
        { value: 'Pernambuco', name: 'Pernambuco' },
        { value: 'Piaui', name: 'Piaui' },
        { value: 'Rio de Janeiro', name: 'Rio de Janeiro' },
        { value: 'Rio Grande do Norte', name: 'Rio Grande do Norte' },
        { value: 'Rio Grande do Sul', name: 'Rio Grande do Sul' },
        { value: 'Rondonia', name: 'Rondonia' },
        { value: 'Roraima', name: 'Roraima' },
        { value: 'Santa Catarina', name: 'Santa Catarina' },
        { value: 'Sao Paulo', name: 'Sao Paulo' },
        { value: 'Sergipe', name: 'Sergipe' },
        { value: 'Tocantins', name: 'Tocantins' },
    ],
    BN: [
        { value: 'Belait', name: 'Belait' },
        { value: 'Brunei and Muara', name: 'Brunei and Muara' },
        { value: 'Temburong', name: 'Temburong' },
        { value: 'Tutong', name: 'Tutong' },
    ],
    BG: [
        { value: 'Blagoevgrad', name: 'Blagoevgrad' },
        { value: 'Burgas', name: 'Burgas' },
        { value: 'Dobrich', name: 'Dobrich' },
        { value: 'Gabrovo', name: 'Gabrovo' },
        { value: 'Khaskovo', name: 'Khaskovo' },
        { value: 'Kurdzhali', name: 'Kurdzhali' },
        { value: 'Kyustendil', name: 'Kyustendil' },
        { value: 'Lovech', name: 'Lovech' },
        { value: 'Montana', name: 'Montana' },
        { value: 'Pazardzhik', name: 'Pazardzhik' },
        { value: 'Pernik', name: 'Pernik' },
        { value: 'Pleven', name: 'Pleven' },
        { value: 'Plovdiv', name: 'Plovdiv' },
        { value: 'Razgrad', name: 'Razgrad' },
        { value: 'Ruse', name: 'Ruse' },
        { value: 'Shumen', name: 'Shumen' },
        { value: 'Silistra', name: 'Silistra' },
        { value: 'Sliven', name: 'Sliven' },
        { value: 'Smolyan', name: 'Smolyan' },
        { value: 'Sofiya', name: 'Sofiya' },
        { value: 'Sofiya-Grad', name: 'Sofiya-Grad' },
        { value: 'Stara Zagora', name: 'Stara Zagora' },
        { value: 'Turgovishte', name: 'Turgovishte' },
        { value: 'Varna', name: 'Varna' },
        { value: 'Veliko Turnovo', name: 'Veliko Turnovo' },
        { value: 'Vidin', name: 'Vidin' },
        { value: 'Vratsa', name: 'Vratsa' },
        { value: 'Yambol', name: 'Yambol' },
    ],
    BF: [
        { value: 'Bale', name: 'Bale' },
        { value: 'Bam', name: 'Bam' },
        { value: 'Banwa', name: 'Banwa' },
        { value: 'Bazega', name: 'Bazega' },
        { value: 'Bougouriba', name: 'Bougouriba' },
        { value: 'Boulgou', name: 'Boulgou' },
        { value: 'Boulkiemde', name: 'Boulkiemde' },
        { value: 'Comoe', name: 'Comoe' },
        { value: 'Ganzourgou', name: 'Ganzourgou' },
        { value: 'Gnagna', name: 'Gnagna' },
        { value: 'Gourma', name: 'Gourma' },
        { value: 'Houet', name: 'Houet' },
        { value: 'Ioba', name: 'Ioba' },
        { value: 'Kadiogo', name: 'Kadiogo' },
        { value: 'Kenedougou', name: 'Kenedougou' },
        { value: 'Komondjari', name: 'Komondjari' },
        { value: 'Kompienga', name: 'Kompienga' },
        { value: 'Kossi', name: 'Kossi' },
        { value: 'Koulpelogo', name: 'Koulpelogo' },
        { value: 'Kouritenga', name: 'Kouritenga' },
        { value: 'Kourweogo', name: 'Kourweogo' },
        { value: 'Leraba', name: 'Leraba' },
        { value: 'Loroum', name: 'Loroum' },
        { value: 'Mouhoun', name: 'Mouhoun' },
        { value: 'Namentenga', name: 'Namentenga' },
        { value: 'Nahouri', name: 'Nahouri' },
        { value: 'Nayala', name: 'Nayala' },
        { value: 'Noumbiel', name: 'Noumbiel' },
        { value: 'Oubritenga', name: 'Oubritenga' },
        { value: 'Oudalan', name: 'Oudalan' },
        { value: 'Passore', name: 'Passore' },
        { value: 'Poni', name: 'Poni' },
        { value: 'Sanguie', name: 'Sanguie' },
        { value: 'Sanmatenga', name: 'Sanmatenga' },
        { value: 'Seno', name: 'Seno' },
        { value: 'Sissili', name: 'Sissili' },
        { value: 'Soum', name: 'Soum' },
        { value: 'Sourou', name: 'Sourou' },
        { value: 'Tapoa', name: 'Tapoa' },
        { value: 'Tuy', name: 'Tuy' },
        { value: 'Yagha', name: 'Yagha' },
        { value: 'Yatenga', name: 'Yatenga' },
        { value: 'Ziro', name: 'Ziro' },
        { value: 'Zondoma', name: 'Zondoma' },
        { value: 'Zoundweogo', name: 'Zoundweogo' },
    ],
    BI: [
        { value: 'Bubanza', name: 'Bubanza' },
        { value: 'Bujumbura Mairie', name: 'Bujumbura Mairie' },
        { value: 'Bujumbura Rural', name: 'Bujumbura Rural' },
        { value: 'Bururi', name: 'Bururi' },
        { value: 'Cankuzo', name: 'Cankuzo' },
        { value: 'Cibitoke', name: 'Cibitoke' },
        { value: 'Gitega', name: 'Gitega' },
        { value: 'Karuzi', name: 'Karuzi' },
        { value: 'Kayanza', name: 'Kayanza' },
        { value: 'Kirundo', name: 'Kirundo' },
        { value: 'Makamba', name: 'Makamba' },
        { value: 'Muramvya', name: 'Muramvya' },
        { value: 'Muyinga', name: 'Muyinga' },
        { value: 'Mwaro', name: 'Mwaro' },
        { value: 'Ngozi', name: 'Ngozi' },
        { value: 'Rutana', name: 'Rutana' },
        { value: 'Ruyigi', name: 'Ruyigi' },
    ],
    KH: [
        { value: 'Banteay Mean Chey', name: 'Banteay Mean Chey' },
        { value: 'Batdambang', name: 'Batdambang' },
        { value: 'Kampong Cham', name: 'Kampong Cham' },
        { value: 'Kampong Chhnang', name: 'Kampong Chhnang' },
        { value: 'Kampong Spoe', name: 'Kampong Spoe' },
        { value: 'Kampong Thum', name: 'Kampong Thum' },
        { value: 'Kampot', name: 'Kampot' },
        { value: 'Kandal', name: 'Kandal' },
        { value: 'Koh Kong', name: 'Koh Kong' },
        { value: 'Kracheh', name: 'Kracheh' },
        { value: 'Mondol Kiri', name: 'Mondol Kiri' },
        { value: 'Otdar Mean Chey', name: 'Otdar Mean Chey' },
        { value: 'Pouthisat', name: 'Pouthisat' },
        { value: 'Preah Vihear', name: 'Preah Vihear' },
        { value: 'Prey Veng', name: 'Prey Veng' },
        { value: 'Rotanakir', name: 'Rotanakir' },
        { value: 'Siem Reab', name: 'Siem Reab' },
        { value: 'Stoeng Treng', name: 'Stoeng Treng' },
        { value: 'Svay Rieng', name: 'Svay Rieng' },
        { value: 'Takao', name: 'Takao' },
        { value: 'Keb', name: 'Keb' },
        { value: 'Pailin', name: 'Pailin' },
        { value: 'Phnom Penh', name: 'Phnom Penh' },
        { value: 'Preah Seihanu', name: 'Preah Seihanu' },
    ],
    CM: [
        { value: 'Adamaoua', name: 'Adamaoua' },
        { value: 'Centre', name: 'Centre' },
        { value: 'Est', name: 'Est' },
        { value: 'Extreme-Nord', name: 'Extreme-Nord' },
        { value: 'Littoral', name: 'Littoral' },
        { value: 'Nord', name: 'Nord' },
        { value: 'Nord-Ouest', name: 'Nord-Ouest' },
        { value: 'Ouest', name: 'Ouest' },
        { value: 'Sud', name: 'Sud' },
        { value: 'Sud-Ouest', name: 'Sud-Ouest' },
    ],
    TD: [
        { value: 'Batha', name: 'Batha' },
        { value: 'Biltine', name: 'Biltine' },
        { value: 'Borkou-Ennedi-Tibesti', name: 'Borkou-Ennedi-Tibesti' },
        { value: 'Chari-Baguirmi', name: 'Chari-Baguirmi' },
        { value: 'Guéra', name: 'Guéra' },
        { value: 'Kanem', name: 'Kanem' },
        { value: 'Lac', name: 'Lac' },
        { value: 'Logone Occidental', name: 'Logone Occidental' },
        { value: 'Logone Oriental', name: 'Logone Oriental' },
        { value: 'Mayo-Kebbi', name: 'Mayo-Kebbi' },
        { value: 'Moyen-Chari', name: 'Moyen-Chari' },
        { value: 'Ouaddaï', name: 'Ouaddaï' },
        { value: 'Salamat', name: 'Salamat' },
        { value: 'Tandjile', name: 'Tandjile' },
    ],
    CL: [
        { value: 'Aysen', name: 'Aysen' },
        { value: 'Antofagasta', name: 'Antofagasta' },
        { value: 'Araucania', name: 'Araucania' },
        { value: 'Atacama', name: 'Atacama' },
        { value: 'Bio-Bio', name: 'Bio-Bio' },
        { value: 'Coquimbo', name: 'Coquimbo' },
        { value: "O'Higgins", name: "O'Higgins" },
        { value: 'Los Lagos', name: 'Los Lagos' },
        { value: 'Magallanes y la Antartica Chilena', name: 'Magallanes y la Antartica Chilena' },
        { value: 'Maule', name: 'Maule' },
        { value: 'Santiago Region Metropolitana', name: 'Santiago Region Metropolitana' },
        { value: 'Tarapaca', name: 'Tarapaca' },
        { value: 'Valparaiso', name: 'Valparaiso' },
    ],
    CN: [
        { value: 'Anhui', name: 'Anhui' },
        { value: 'Fujian', name: 'Fujian' },
        { value: 'Gansu', name: 'Gansu' },
        { value: 'Guangdong', name: 'Guangdong' },
        { value: 'Guizhou', name: 'Guizhou' },
        { value: 'Hainan', name: 'Hainan' },
        { value: 'Hebei', name: 'Hebei' },
        { value: 'Heilongjiang', name: 'Heilongjiang' },
        { value: 'Henan', name: 'Henan' },
        { value: 'Hubei', name: 'Hubei' },
        { value: 'Hunan', name: 'Hunan' },
        { value: 'Jiangsu', name: 'Jiangsu' },
        { value: 'Jiangxi', name: 'Jiangxi' },
        { value: 'Jilin', name: 'Jilin' },
        { value: 'Liaoning', name: 'Liaoning' },
        { value: 'Qinghai', name: 'Qinghai' },
        { value: 'Shaanxi', name: 'Shaanxi' },
        { value: 'Shandong', name: 'Shandong' },
        { value: 'Shanxi', name: 'Shanxi' },
        { value: 'Sichuan', name: 'Sichuan' },
        { value: 'Yunnan', name: 'Yunnan' },
        { value: 'Zhejiang', name: 'Zhejiang' },
        { value: 'Guangxi', name: 'Guangxi' },
        { value: 'Nei Mongol', name: 'Nei Mongol' },
        { value: 'Ningxia', name: 'Ningxia' },
        { value: 'Xinjiang', name: 'Xinjiang' },
        { value: 'Xizang (Tibet)', name: 'Xizang (Tibet)' },
        { value: 'Beijing', name: 'Beijing' },
        { value: 'Chongqing', name: 'Chongqing' },
        { value: 'Shanghai', name: 'Shanghai' },
        { value: 'Tianjin', name: 'Tianjin' },
    ],
    CO: [
        { value: 'Amazonas', name: 'Amazonas' },
        { value: 'Antioquia', name: 'Antioquia' },
        { value: 'Arauca', name: 'Arauca' },
        { value: 'Atlantico', name: 'Atlantico' },
        { value: 'Bogota District Capital', name: 'Bogota District Capital' },
        { value: 'Bolivar', name: 'Bolivar' },
        { value: 'Boyaca', name: 'Boyaca' },
        { value: 'Caldas', name: 'Caldas' },
        { value: 'Caqueta', name: 'Caqueta' },
        { value: 'Casanare', name: 'Casanare' },
        { value: 'Cauca', name: 'Cauca' },
        { value: 'Cesar', name: 'Cesar' },
        { value: 'Choco', name: 'Choco' },
        { value: 'Cordoba', name: 'Cordoba' },
        { value: 'Cundinamarca', name: 'Cundinamarca' },
        { value: 'Guainia', name: 'Guainia' },
        { value: 'Guaviare', name: 'Guaviare' },
        { value: 'Huila', name: 'Huila' },
        { value: 'La Guajira', name: 'La Guajira' },
        { value: 'Magdalena', name: 'Magdalena' },
        { value: 'Meta', name: 'Meta' },
        { value: 'Narino', name: 'Narino' },
        { value: 'Norte de Santander', name: 'Norte de Santander' },
        { value: 'Putumayo', name: 'Putumayo' },
        { value: 'Quindio', name: 'Quindio' },
        { value: 'Risaralda', name: 'Risaralda' },
        { value: 'San Andres & Providencia', name: 'San Andres & Providencia' },
        { value: 'Santander', name: 'Santander' },
        { value: 'Sucre', name: 'Sucre' },
        { value: 'Tolima', name: 'Tolima' },
        { value: 'Valle del Cauca', name: 'Valle del Cauca' },
        { value: 'Vaupes', name: 'Vaupes' },
        { value: 'Vichada', name: 'Vichada' },
    ],
    KM: [
        { value: 'Grande Comore (Njazidja)', name: 'Grande Comore (Njazidja)' },
        { value: 'Anjouan (Nzwani)', name: 'Anjouan (Nzwani)' },
        { value: 'Moheli (Mwali)', name: 'Moheli (Mwali)' },
    ],
    CR: [
        { value: 'Alajuela', name: 'Alajuela' },
        { value: 'Cartago', name: 'Cartago' },
        { value: 'Guanacaste', name: 'Guanacaste' },
        { value: 'Heredia', name: 'Heredia' },
        { value: 'Limon', name: 'Limon' },
        { value: 'Puntarenas', name: 'Puntarenas' },
        { value: 'San Jose', name: 'San Jose' },
    ],
    HR: [
        { value: 'Bjelovarsko-Bilogorska', name: 'Bjelovarsko-Bilogorska' },
        { value: 'Brodsko-Posavska', name: 'Brodsko-Posavska' },
        { value: 'Dubrovacko-Neretvanska', name: 'Dubrovacko-Neretvanska' },
        { value: 'Istarska', name: 'Istarska' },
        { value: 'Karlovacka', name: 'Karlovacka' },
        { value: 'Koprivnicko-Krizevacka', name: 'Koprivnicko-Krizevacka' },
        { value: 'Krapinsko-Zagorska', name: 'Krapinsko-Zagorska' },
        { value: 'Licko-Senjska', name: 'Licko-Senjska' },
        { value: 'Medimurska', name: 'Medimurska' },
        { value: 'Osjecko-Baranjska', name: 'Osjecko-Baranjska' },
        { value: 'Pozesko-Slavonska', name: 'Pozesko-Slavonska' },
        { value: 'Primorsko-Goranska', name: 'Primorsko-Goranska' },
        { value: 'Sibensko-Kninska', name: 'Sibensko-Kninska' },
        { value: 'Sisacko-Moslavacka', name: 'Sisacko-Moslavacka' },
        { value: 'Splitsko-Dalmatinska', name: 'Splitsko-Dalmatinska' },
        { value: 'Varazdinska', name: 'Varazdinska' },
        { value: 'Viroviticko-Podravska', name: 'Viroviticko-Podravska' },
        { value: 'Vukovarsko-Srijemska', name: 'Vukovarsko-Srijemska' },
        { value: 'Zadarska', name: 'Zadarska' },
        { value: 'Zagreb', name: 'Zagreb' },
        { value: 'Zagrebacka', name: 'Zagrebacka' },
    ],
    CY: [
        { value: 'Famagusta', name: 'Famagusta' },
        { value: 'Kyrenia', name: 'Kyrenia' },
        { value: 'Larnaca', name: 'Larnaca' },
        { value: 'Limassol', name: 'Limassol' },
        { value: 'Nicosia', name: 'Nicosia' },
        { value: 'Paphos', name: 'Paphos' },
    ],
    DK: [
        { value: 'Arhus', name: 'Arhus' },
        { value: 'Bornholm', name: 'Bornholm' },
        { value: 'Frederiksberg', name: 'Frederiksberg' },
        { value: 'Frederiksborg', name: 'Frederiksborg' },
        { value: 'Fyn', name: 'Fyn' },
        { value: 'Kobenhavn', name: 'Kobenhavn' },
        { value: 'Kobenhavns', name: 'Kobenhavns' },
        { value: 'Nordjylland', name: 'Nordjylland' },
        { value: 'Ribe', name: 'Ribe' },
        { value: 'Ringkobing', name: 'Ringkobing' },
        { value: 'Roskilde', name: 'Roskilde' },
        { value: 'Sonderjylland', name: 'Sonderjylland' },
        { value: 'Storstrom', name: 'Storstrom' },
        { value: 'Vejle', name: 'Vejle' },
        { value: 'Vestsjalland', name: 'Vestsjalland' },
        { value: 'Viborg', name: 'Viborg' },
    ],
    DJ: [
        { value: 'Ali Sabih', name: 'Ali Sabih' },
        { value: 'Dikhil', name: 'Dikhil' },
        { value: 'Djibouti', name: 'Djibouti' },
        { value: 'Obock', name: 'Obock' },
        { value: 'Tadjoura', name: 'Tadjoura' },
    ],
    DM: [
        { value: 'Saint Andrew', name: 'Saint Andrew' },
        { value: 'Saint David', name: 'Saint David' },
        { value: 'Saint George', name: 'Saint George' },
        { value: 'Saint John', name: 'Saint John' },
        { value: 'Saint Joseph', name: 'Saint Joseph' },
        { value: 'Saint Luke', name: 'Saint Luke' },
        { value: 'Saint Mark', name: 'Saint Mark' },
        { value: 'Saint Patrick', name: 'Saint Patrick' },
        { value: 'Saint Paul', name: 'Saint Paul' },
        { value: 'Saint Peter', name: 'Saint Peter' },
    ],
    DO: [
        { value: 'Azua', name: 'Azua' },
        { value: 'Baoruco', name: 'Baoruco' },
        { value: 'Barahona', name: 'Barahona' },
        { value: 'Dajabon', name: 'Dajabon' },
        { value: 'Distrito Nacional', name: 'Distrito Nacional' },
        { value: 'Duarte', name: 'Duarte' },
        { value: 'Elias Pina', name: 'Elias Pina' },
        { value: 'El Seibo', name: 'El Seibo' },
        { value: 'Espaillat', name: 'Espaillat' },
        { value: 'Hato Mayor', name: 'Hato Mayor' },
        { value: 'Independencia', name: 'Independencia' },
        { value: 'La Altagracia', name: 'La Altagracia' },
        { value: 'La Romana', name: 'La Romana' },
        { value: 'La Vega', name: 'La Vega' },
        { value: 'Maria Trinidad Sanchez', name: 'Maria Trinidad Sanchez' },
        { value: 'Monsenor Nouel', name: 'Monsenor Nouel' },
        { value: 'Monte Cristi', name: 'Monte Cristi' },
        { value: 'Monte Plata', name: 'Monte Plata' },
        { value: 'Pedernales', name: 'Pedernales' },
        { value: 'Peravia', name: 'Peravia' },
        { value: 'Puerto Plata', name: 'Puerto Plata' },
        { value: 'Salcedo', name: 'Salcedo' },
        { value: 'Samana', name: 'Samana' },
        { value: 'Sanchez Ramirez', name: 'Sanchez Ramirez' },
        { value: 'San Cristobal', name: 'San Cristobal' },
        { value: 'San Jose de Ocoa', name: 'San Jose de Ocoa' },
        { value: 'San Juan', name: 'San Juan' },
        { value: 'San Pedro de Macoris', name: 'San Pedro de Macoris' },
        { value: 'Santiago', name: 'Santiago' },
        { value: 'Santiago Rodriguez', name: 'Santiago Rodriguez' },
        { value: 'Santo Domingo', name: 'Santo Domingo' },
        { value: 'Valverde', name: 'Valverde' },
    ],
    EC: [
        { value: 'Azuay', name: 'Azuay' },
        { value: 'Bolivar', name: 'Bolivar' },
        { value: 'Canar', name: 'Canar' },
        { value: 'Carchi', name: 'Carchi' },
        { value: 'Chimborazo', name: 'Chimborazo' },
        { value: 'Cotopaxi', name: 'Cotopaxi' },
        { value: 'El Oro', name: 'El Oro' },
        { value: 'Esmeraldas', name: 'Esmeraldas' },
        { value: 'Galapagos', name: 'Galapagos' },
        { value: 'Guayas', name: 'Guayas' },
        { value: 'Imbabura', name: 'Imbabura' },
        { value: 'Loja', name: 'Loja' },
        { value: 'Los Rios', name: 'Los Rios' },
        { value: 'Manabi', name: 'Manabi' },
        { value: 'Morona-Santiago', name: 'Morona-Santiago' },
        { value: 'Napo', name: 'Napo' },
        { value: 'Orellana', name: 'Orellana' },
        { value: 'Pastaza', name: 'Pastaza' },
        { value: 'Pichincha', name: 'Pichincha' },
        { value: 'Sucumbios', name: 'Sucumbios' },
        { value: 'Tungurahua', name: 'Tungurahua' },
        { value: 'Zamora-Chinchipe', name: 'Zamora-Chinchipe' },
    ],
    GQ: [
        { value: 'Annobon', name: 'Annobon' },
        { value: 'Bioko Norte', name: 'Bioko Norte' },
        { value: 'Bioko Sur', name: 'Bioko Sur' },
        { value: 'Centro Sur', name: 'Centro Sur' },
        { value: 'Kie-Ntem', name: 'Kie-Ntem' },
        { value: 'Litoral', name: 'Litoral' },
        { value: 'Wele-Nzas', name: 'Wele-Nzas' },
    ],
    ER: [
        { value: 'Anseba', name: 'Anseba' },
        { value: 'Debub', name: 'Debub' },
        { value: "Debubawi K'eyih Bahri", name: "Debubawi K'eyih Bahri" },
        { value: 'Gash Barka', name: 'Gash Barka' },
        { value: "Ma'akel", name: "Ma'akel" },
        { value: 'Semenawi Keyih Bahri', name: 'Semenawi Keyih Bahri' },
    ],
    EE: [
        { value: 'Harjumaa (Tallinn)', name: 'Harjumaa (Tallinn)' },
        { value: 'Hiiumaa (Kardla)', name: 'Hiiumaa (Kardla)' },
        { value: 'Ida-Virumaa (Johvi)', name: 'Ida-Virumaa (Johvi)' },
        { value: 'Jarvamaa (Paide)', name: 'Jarvamaa (Paide)' },
        { value: 'Jogevamaa (Jogeva)', name: 'Jogevamaa (Jogeva)' },
        { value: 'Laanemaa (Haapsalu)', name: 'Laanemaa (Haapsalu)' },
        { value: 'Laane-Virumaa (Rakvere)', name: 'Laane-Virumaa (Rakvere)' },
        { value: 'Parnumaa (Parnu)', name: 'Parnumaa (Parnu)' },
        { value: 'Polvamaa (Polva)', name: 'Polvamaa (Polva)' },
        { value: 'Raplamaa (Rapla)', name: 'Raplamaa (Rapla)' },
        { value: 'Saaremaa (Kuressaare)', name: 'Saaremaa (Kuressaare)' },
        { value: 'Tartumaa (Tartu)', name: 'Tartumaa (Tartu)' },
        { value: 'Valgamaa (Valga)', name: 'Valgamaa (Valga)' },
        { value: 'Viljandimaa (Viljandi)', name: 'Viljandimaa (Viljandi)' },
        { value: 'Vorumaa (Voru)', name: 'Vorumaa (Voru)' },
    ],
    ET: [
        { value: 'Addis Ababa', name: 'Addis Ababa' },
        { value: 'Afar', name: 'Afar' },
        { value: 'Amhara', name: 'Amhara' },
        { value: 'Binshangul Gumuz', name: 'Binshangul Gumuz' },
        { value: 'Dire Dawa', name: 'Dire Dawa' },
        { value: 'Gambela Hizboch', name: 'Gambela Hizboch' },
        { value: 'Harari', name: 'Harari' },
        { value: 'Oromia', name: 'Oromia' },
        { value: 'Somali', name: 'Somali' },
        { value: 'Tigray', name: 'Tigray' },
        {
            value: 'Southern Nations, Nationalities, and Peoples Region',
            name: 'Southern Nations, Nationalities, and Peoples Region',
        },
    ],
    FJ: [
        { value: 'Central (Suva)', name: 'Central (Suva)' },
        { value: 'Eastern (Levuka)', name: 'Eastern (Levuka)' },
        { value: 'Northern (Labasa)', name: 'Northern (Labasa)' },
        { value: 'Rotuma', name: 'Rotuma' },
        { value: 'Western (Lautoka)', name: 'Western (Lautoka)' },
    ],
    FI: [
        { value: 'Aland', name: 'Aland' },
        { value: 'Etela-Suomen Laani', name: 'Etela-Suomen Laani' },
        { value: 'Ita-Suomen Laani', name: 'Ita-Suomen Laani' },
        { value: 'Lansi-Suomen Laani', name: 'Lansi-Suomen Laani' },
        { value: 'Lappi', name: 'Lappi' },
        { value: 'Oulun Laani', name: 'Oulun Laani' },
    ],
    FR: [
        { value: 'Alsace', name: 'Alsace' },
        { value: 'Aquitaine', name: 'Aquitaine' },
        { value: 'Auvergne', name: 'Auvergne' },
        { value: 'Basse-Normandie', name: 'Basse-Normandie' },
        { value: 'Bourgogne', name: 'Bourgogne' },
        { value: 'Bretagne', name: 'Bretagne' },
        { value: 'Centre', name: 'Centre' },
        { value: 'Champagne-Ardenne', name: 'Champagne-Ardenne' },
        { value: 'Corse', name: 'Corse' },
        { value: 'Franche-Comte', name: 'Franche-Comte' },
        { value: 'Haute-Normandie', name: 'Haute-Normandie' },
        { value: 'Ile-de-France', name: 'Ile-de-France' },
        { value: 'Languedoc-Roussillon', name: 'Languedoc-Roussillon' },
        { value: 'Limousin', name: 'Limousin' },
        { value: 'Lorraine', name: 'Lorraine' },
        { value: 'Midi-Pyrenees', name: 'Midi-Pyrenees' },
        { value: 'Nord-Pas-de-Calais', name: 'Nord-Pas-de-Calais' },
        { value: 'Pays de la Loire', name: 'Pays de la Loire' },
        { value: 'Picardie', name: 'Picardie' },
        { value: 'Poitou-Charentes', name: 'Poitou-Charentes' },
        { value: "Provence-Alpes-Cote d'Azur", name: "Provence-Alpes-Cote d'Azur" },
        { value: 'Rhone-Alpes', name: 'Rhone-Alpes' },
    ],
    GA: [
        { value: 'Estuaire', name: 'Estuaire' },
        { value: 'Haut-Ogooue', name: 'Haut-Ogooue' },
        { value: 'Moyen-Ogooue', name: 'Moyen-Ogooue' },
        { value: 'Ngounie', name: 'Ngounie' },
        { value: 'Nyanga', name: 'Nyanga' },
        { value: 'Ogooue-Ivindo', name: 'Ogooue-Ivindo' },
        { value: 'Ogooue-Lolo', name: 'Ogooue-Lolo' },
        { value: 'Ogooue-Maritime', name: 'Ogooue-Maritime' },
        { value: 'Woleu-Ntem', name: 'Woleu-Ntem' },
    ],
    GM: [
        { value: 'Banjul', name: 'Banjul' },
        { value: 'Central River', name: 'Central River' },
        { value: 'Lower River', name: 'Lower River' },
        { value: 'North Bank', name: 'North Bank' },
        { value: 'Upper River', name: 'Upper River' },
        { value: 'Western', name: 'Western' },
    ],
    DE: [
        { value: 'Baden-Wuerttemberg', name: 'Baden-Wuerttemberg' },
        { value: 'Bayern', name: 'Bayern' },
        { value: 'Berlin', name: 'Berlin' },
        { value: 'Brandenburg', name: 'Brandenburg' },
        { value: 'Bremen', name: 'Bremen' },
        { value: 'Hamburg', name: 'Hamburg' },
        { value: 'Hessen', name: 'Hessen' },
        { value: 'Mecklenburg-Vorpommern', name: 'Mecklenburg-Vorpommern' },
        { value: 'Niedersachsen', name: 'Niedersachsen' },
        { value: 'Nordrhein-Westfalen', name: 'Nordrhein-Westfalen' },
        { value: 'Rheinland-Pfalz', name: 'Rheinland-Pfalz' },
        { value: 'Saarland', name: 'Saarland' },
        { value: 'Sachsen', name: 'Sachsen' },
        { value: 'Sachsen-Anhalt', name: 'Sachsen-Anhalt' },
        { value: 'Schleswig-Holstein', name: 'Schleswig-Holstein' },
        { value: 'Thueringen', name: 'Thueringen' },
    ],
    GH: [
        { value: 'Ashanti', name: 'Ashanti' },
        { value: 'Brong-Ahafo', name: 'Brong-Ahafo' },
        { value: 'Central', name: 'Central' },
        { value: 'Eastern', name: 'Eastern' },
        { value: 'Greater Accra', name: 'Greater Accra' },
        { value: 'Northern', name: 'Northern' },
        { value: 'Upper East', name: 'Upper East' },
        { value: 'Upper West', name: 'Upper West' },
        { value: 'Volta', name: 'Volta' },
        { value: 'Western', name: 'Western' },
    ],
    GR: [
        { value: 'Agion Oros', name: 'Agion Oros' },
        { value: 'Achaia', name: 'Achaia' },
        { value: 'Aitolia kai Akarmania', name: 'Aitolia kai Akarmania' },
        { value: 'Argolis', name: 'Argolis' },
        { value: 'Arkadia', name: 'Arkadia' },
        { value: 'Arta', name: 'Arta' },
        { value: 'Attiki', name: 'Attiki' },
        { value: 'Chalkidiki', name: 'Chalkidiki' },
        { value: 'Chanion', name: 'Chanion' },
        { value: 'Chios', name: 'Chios' },
        { value: 'Dodekanisos', name: 'Dodekanisos' },
        { value: 'Drama', name: 'Drama' },
        { value: 'Evros', name: 'Evros' },
        { value: 'Evrytania', name: 'Evrytania' },
        { value: 'Evvoia', name: 'Evvoia' },
        { value: 'Florina', name: 'Florina' },
        { value: 'Fokidos', name: 'Fokidos' },
        { value: 'Fthiotis', name: 'Fthiotis' },
        { value: 'Grevena', name: 'Grevena' },
        { value: 'Ileia', name: 'Ileia' },
        { value: 'Imathia', name: 'Imathia' },
        { value: 'Ioannina', name: 'Ioannina' },
        { value: 'Irakleion', name: 'Irakleion' },
        { value: 'Karditsa', name: 'Karditsa' },
        { value: 'Kastoria', name: 'Kastoria' },
        { value: 'Kavala', name: 'Kavala' },
        { value: 'Kefallinia', name: 'Kefallinia' },
        { value: 'Kerkyra', name: 'Kerkyra' },
        { value: 'Kilkis', name: 'Kilkis' },
        { value: 'Korinthia', name: 'Korinthia' },
        { value: 'Kozani', name: 'Kozani' },
        { value: 'Kyklades', name: 'Kyklades' },
        { value: 'Lakonia', name: 'Lakonia' },
        { value: 'Larisa', name: 'Larisa' },
        { value: 'Lasithi', name: 'Lasithi' },
        { value: 'Lefkas', name: 'Lefkas' },
        { value: 'Lesvos', name: 'Lesvos' },
        { value: 'Magnisia', name: 'Magnisia' },
        { value: 'Messinia', name: 'Messinia' },
        { value: 'Pella', name: 'Pella' },
        { value: 'Pieria', name: 'Pieria' },
        { value: 'Preveza', name: 'Preveza' },
        { value: 'Rethynnis', name: 'Rethynnis' },
        { value: 'Rodopi', name: 'Rodopi' },
        { value: 'Samos', name: 'Samos' },
        { value: 'Serrai', name: 'Serrai' },
        { value: 'Thesprotia', name: 'Thesprotia' },
        { value: 'Thessaloniki', name: 'Thessaloniki' },
        { value: 'Trikala', name: 'Trikala' },
        { value: 'Voiotia', name: 'Voiotia' },
        { value: 'Xanthi', name: 'Xanthi' },
        { value: 'Zakynthos', name: 'Zakynthos' },
    ],
    GD: [
        { value: 'Carriacou and Petit Martinique', name: 'Carriacou and Petit Martinique' },
        { value: 'Saint Andrew', name: 'Saint Andrew' },
        { value: 'Saint David', name: 'Saint David' },
        { value: 'Saint George', name: 'Saint George' },
        { value: 'Saint John', name: 'Saint John' },
        { value: 'Saint Mark', name: 'Saint Mark' },
        { value: 'Saint Patrick', name: 'Saint Patrick' },
    ],
    GT: [
        { value: 'Alta Verapaz', name: 'Alta Verapaz' },
        { value: 'Baja Verapaz', name: 'Baja Verapaz' },
        { value: 'Chimaltenango', name: 'Chimaltenango' },
        { value: 'Chiquimula', name: 'Chiquimula' },
        { value: 'El Progreso', name: 'El Progreso' },
        { value: 'Escuintla', name: 'Escuintla' },
        { value: 'Guatemala', name: 'Guatemala' },
        { value: 'Huehuetenango', name: 'Huehuetenango' },
        { value: 'Izabal', name: 'Izabal' },
        { value: 'Jalapa', name: 'Jalapa' },
        { value: 'Jutiapa', name: 'Jutiapa' },
        { value: 'Peten', name: 'Peten' },
        { value: 'Quetzaltenango', name: 'Quetzaltenango' },
        { value: 'Quiche', name: 'Quiche' },
        { value: 'Retalhuleu', name: 'Retalhuleu' },
        { value: 'Sacatepequez', name: 'Sacatepequez' },
        { value: 'San Marcos', name: 'San Marcos' },
        { value: 'Santa Rosa', name: 'Santa Rosa' },
        { value: 'Solola', name: 'Solola' },
        { value: 'Suchitepequez', name: 'Suchitepequez' },
        { value: 'Totonicapan', name: 'Totonicapan' },
        { value: 'Zacapa', name: 'Zacapa' },
    ],
    GN: [
        { value: 'Beyla', name: 'Beyla' },
        { value: 'Boffa', name: 'Boffa' },
        { value: 'Boke', name: 'Boke' },
        { value: 'Conakry', name: 'Conakry' },
        { value: 'Coyah', name: 'Coyah' },
        { value: 'Dabola', name: 'Dabola' },
        { value: 'Dalaba', name: 'Dalaba' },
        { value: 'Dinguiraye', name: 'Dinguiraye' },
        { value: 'Dubreka', name: 'Dubreka' },
        { value: 'Faranah', name: 'Faranah' },
        { value: 'Forecariah', name: 'Forecariah' },
        { value: 'Fria', name: 'Fria' },
        { value: 'Gaoual', name: 'Gaoual' },
        { value: 'Gueckedou', name: 'Gueckedou' },
        { value: 'Kankan', name: 'Kankan' },
        { value: 'Kerouane', name: 'Kerouane' },
        { value: 'Kindia', name: 'Kindia' },
        { value: 'Kissidougou', name: 'Kissidougou' },
        { value: 'Koubia', name: 'Koubia' },
        { value: 'Koundara', name: 'Koundara' },
        { value: 'Kouroussa', name: 'Kouroussa' },
        { value: 'Labe', name: 'Labe' },
        { value: 'Lelouma', name: 'Lelouma' },
        { value: 'Lola', name: 'Lola' },
        { value: 'Macenta', name: 'Macenta' },
        { value: 'Mali', name: 'Mali' },
        { value: 'Mamou', name: 'Mamou' },
        { value: 'Mandiana', name: 'Mandiana' },
        { value: 'Nzerekore', name: 'Nzerekore' },
        { value: 'Pita', name: 'Pita' },
        { value: 'Siguiri', name: 'Siguiri' },
        { value: 'Telimele', name: 'Telimele' },
        { value: 'Tougue', name: 'Tougue' },
        { value: 'Yomou', name: 'Yomou' },
    ],
    GW: [
        { value: 'Bafata', name: 'Bafata' },
        { value: 'Biombo', name: 'Biombo' },
        { value: 'Bissau', name: 'Bissau' },
        { value: 'Bolama', name: 'Bolama' },
        { value: 'Cacheu', name: 'Cacheu' },
        { value: 'Gabu', name: 'Gabu' },
        { value: 'Oio', name: 'Oio' },
        { value: 'Quinara', name: 'Quinara' },
        { value: 'Tombali', name: 'Tombali' },
    ],
    GY: [
        { value: 'Barima-Waini', name: 'Barima-Waini' },
        { value: 'Cuyuni-Mazaruni', name: 'Cuyuni-Mazaruni' },
        { value: 'Demerara-Mahaica', name: 'Demerara-Mahaica' },
        { value: 'East Berbice-Corentyne', name: 'East Berbice-Corentyne' },
        { value: 'Essequibo Islands-West Demerara', name: 'Essequibo Islands-West Demerara' },
        { value: 'Mahaica-Berbice', name: 'Mahaica-Berbice' },
        { value: 'Pomeroon-Supenaam', name: 'Pomeroon-Supenaam' },
        { value: 'Potaro-Siparuni', name: 'Potaro-Siparuni' },
        { value: 'Upper Demerara-Berbice', name: 'Upper Demerara-Berbice' },
        { value: 'Upper Takutu-Upper Essequibo', name: 'Upper Takutu-Upper Essequibo' },
    ],
    HT: [
        { value: 'Artibonite', name: 'Artibonite' },
        { value: 'Centre', name: 'Centre' },
        { value: "Grand 'Anse", name: "Grand 'Anse" },
        { value: 'Nord', name: 'Nord' },
        { value: 'Nord-Est', name: 'Nord-Est' },
        { value: 'Nord-Ouest', name: 'Nord-Ouest' },
        { value: 'Ouest', name: 'Ouest' },
        { value: 'Sud', name: 'Sud' },
        { value: 'Sud-Est', name: 'Sud-Est' },
    ],
    HN: [
        { value: 'Atlantida', name: 'Atlantida' },
        { value: 'Choluteca', name: 'Choluteca' },
        { value: 'Colon', name: 'Colon' },
        { value: 'Comayagua', name: 'Comayagua' },
        { value: 'Copan', name: 'Copan' },
        { value: 'Cortes', name: 'Cortes' },
        { value: 'El Paraiso', name: 'El Paraiso' },
        { value: 'Francisco Morazan', name: 'Francisco Morazan' },
        { value: 'Gracias a Dios', name: 'Gracias a Dios' },
        { value: 'Intibuca', name: 'Intibuca' },
        { value: 'Islas de la Bahia', name: 'Islas de la Bahia' },
        { value: 'La Paz', name: 'La Paz' },
        { value: 'Lempira', name: 'Lempira' },
        { value: 'Ocotepeque', name: 'Ocotepeque' },
        { value: 'Olancho', name: 'Olancho' },
        { value: 'Santa Barbara', name: 'Santa Barbara' },
        { value: 'Valle', name: 'Valle' },
        { value: 'Yoro', name: 'Yoro' },
    ],
    HU: [
        { value: 'Bacs-Kiskun', name: 'Bacs-Kiskun' },
        { value: 'Baranya', name: 'Baranya' },
        { value: 'Bekes', name: 'Bekes' },
        { value: 'Borsod-Abauj-Zemplen', name: 'Borsod-Abauj-Zemplen' },
        { value: 'Csongrad', name: 'Csongrad' },
        { value: 'Fejer', name: 'Fejer' },
        { value: 'Gyor-Moson-Sopron', name: 'Gyor-Moson-Sopron' },
        { value: 'Hajdu-Bihar', name: 'Hajdu-Bihar' },
        { value: 'Heves', name: 'Heves' },
        { value: 'Jasz-Nagykun-Szolnok', name: 'Jasz-Nagykun-Szolnok' },
        { value: 'Komarom-Esztergom', name: 'Komarom-Esztergom' },
        { value: 'Nograd', name: 'Nograd' },
        { value: 'Pest', name: 'Pest' },
        { value: 'Somogy', name: 'Somogy' },
        { value: 'Szabolcs-Szatmar-Bereg', name: 'Szabolcs-Szatmar-Bereg' },
        { value: 'Tolna', name: 'Tolna' },
        { value: 'Vas', name: 'Vas' },
        { value: 'Veszprem', name: 'Veszprem' },
        { value: 'Zala', name: 'Zala' },
        { value: 'Bekescsaba', name: 'Bekescsaba' },
        { value: 'Debrecen', name: 'Debrecen' },
        { value: 'Dunaujvaros', name: 'Dunaujvaros' },
        { value: 'Eger', name: 'Eger' },
        { value: 'Gyor', name: 'Gyor' },
        { value: 'Hodmezovasarhely', name: 'Hodmezovasarhely' },
        { value: 'Kaposvar', name: 'Kaposvar' },
        { value: 'Kecskemet', name: 'Kecskemet' },
        { value: 'Miskolc', name: 'Miskolc' },
        { value: 'Nagykanizsa', name: 'Nagykanizsa' },
        { value: 'Nyiregyhaza', name: 'Nyiregyhaza' },
        { value: 'Pecs', name: 'Pecs' },
        { value: 'Sopron', name: 'Sopron' },
        { value: 'Szeged', name: 'Szeged' },
        { value: 'Szekesfehervar', name: 'Szekesfehervar' },
        { value: 'Szolnok', name: 'Szolnok' },
        { value: 'Szombathely', name: 'Szombathely' },
        { value: 'Tatabanya', name: 'Tatabanya' },
        { value: 'Veszprem', name: 'Veszprem' },
        { value: 'Zalaegerszeg', name: 'Zalaegerszeg' },
    ],
    IS: [
        { value: 'Austurland', name: 'Austurland' },
        { value: 'Hofudhborgarsvaedhi', name: 'Hofudhborgarsvaedhi' },
        { value: 'Nordhurland Eystra', name: 'Nordhurland Eystra' },
        { value: 'Nordhurland Vestra', name: 'Nordhurland Vestra' },
        { value: 'Sudhurland', name: 'Sudhurland' },
        { value: 'Sudhurnes', name: 'Sudhurnes' },
        { value: 'Vestfirdhir', name: 'Vestfirdhir' },
        { value: 'Vesturland', name: 'Vesturland' },
    ],
    IN: [
        { value: 'Andaman and Nicobar Islands', name: 'Andaman and Nicobar Islands' },
        { value: 'Andhra Pradesh', name: 'Andhra Pradesh' },
        { value: 'Arunachal Pradesh', name: 'Arunachal Pradesh' },
        { value: 'Assam', name: 'Assam' },
        { value: 'Bihar', name: 'Bihar' },
        { value: 'Chandigarh', name: 'Chandigarh' },
        { value: 'Chhattisgarh', name: 'Chhattisgarh' },
        { value: 'Dadra and Nagar Haveli', name: 'Dadra and Nagar Haveli' },
        { value: 'Daman and Diu', name: 'Daman and Diu' },
        { value: 'Delhi', name: 'Delhi' },
        { value: 'Goa', name: 'Goa' },
        { value: 'Gujarat', name: 'Gujarat' },
        { value: 'Haryana', name: 'Haryana' },
        { value: 'Himachal Pradesh', name: 'Himachal Pradesh' },
        { value: 'Jammu and Kashmir', name: 'Jammu and Kashmir' },
        { value: 'Jharkhand', name: 'Jharkhand' },
        { value: 'Karnataka', name: 'Karnataka' },
        { value: 'Kerala', name: 'Kerala' },
        { value: 'Lakshadweep', name: 'Lakshadweep' },
        { value: 'Madhya Pradesh', name: 'Madhya Pradesh' },
        { value: 'Maharashtra', name: 'Maharashtra' },
        { value: 'Manipur', name: 'Manipur' },
        { value: 'Meghalaya', name: 'Meghalaya' },
        { value: 'Mizoram', name: 'Mizoram' },
        { value: 'Nagaland', name: 'Nagaland' },
        { value: 'Orissa', name: 'Orissa' },
        { value: 'Pondicherry', name: 'Pondicherry' },
        { value: 'Punjab', name: 'Punjab' },
        { value: 'Rajasthan', name: 'Rajasthan' },
        { value: 'Sikkim', name: 'Sikkim' },
        { value: 'Tamil Nadu', name: 'Tamil Nadu' },
        { value: 'Tripura', name: 'Tripura' },
        { value: 'Uttaranchal', name: 'Uttaranchal' },
        { value: 'Uttar Pradesh', name: 'Uttar Pradesh' },
        { value: 'West Bengal', name: 'West Bengal' },
    ],
    ID: [
        { value: 'Aceh', name: 'Aceh' },
        { value: 'Bali', name: 'Bali' },
        { value: 'Banten', name: 'Banten' },
        { value: 'Bengkulu', name: 'Bengkulu' },
        { value: 'Gorontalo', name: 'Gorontalo' },
        { value: 'Irian Jaya Barat', name: 'Irian Jaya Barat' },
        { value: 'Jakarta Raya', name: 'Jakarta Raya' },
        { value: 'Jambi', name: 'Jambi' },
        { value: 'Jawa Barat', name: 'Jawa Barat' },
        { value: 'Jawa Tengah', name: 'Jawa Tengah' },
        { value: 'Jawa Timur', name: 'Jawa Timur' },
        { value: 'Kalimantan Barat', name: 'Kalimantan Barat' },
        { value: 'Kalimantan Selatan', name: 'Kalimantan Selatan' },
        { value: 'Kalimantan Tengah', name: 'Kalimantan Tengah' },
        { value: 'Kalimantan Timur', name: 'Kalimantan Timur' },
        { value: 'Kepulauan Bangka Belitung', name: 'Kepulauan Bangka Belitung' },
        { value: 'Kepulauan Riau', name: 'Kepulauan Riau' },
        { value: 'Lampung', name: 'Lampung' },
        { value: 'Maluku', name: 'Maluku' },
        { value: 'Maluku Utara', name: 'Maluku Utara' },
        { value: 'Nusa Tenggara Barat', name: 'Nusa Tenggara Barat' },
        { value: 'Nusa Tenggara Timur', name: 'Nusa Tenggara Timur' },
        { value: 'Papua', name: 'Papua' },
        { value: 'Riau', name: 'Riau' },
        { value: 'Sulawesi Barat', name: 'Sulawesi Barat' },
        { value: 'Sulawesi Selatan', name: 'Sulawesi Selatan' },
        { value: 'Sulawesi Tengah', name: 'Sulawesi Tengah' },
        { value: 'Sulawesi Tenggara', name: 'Sulawesi Tenggara' },
        { value: 'Sulawesi Utara', name: 'Sulawesi Utara' },
        { value: 'Sumatera Barat', name: 'Sumatera Barat' },
        { value: 'Sumatera Selatan', name: 'Sumatera Selatan' },
        { value: 'Sumatera Utara', name: 'Sumatera Utara' },
        { value: 'Yogyakarta', name: 'Yogyakarta' },
    ],
    IE: [
        { value: 'Carlow', name: 'Carlow' },
        { value: 'Cavan', name: 'Cavan' },
        { value: 'Clare', name: 'Clare' },
        { value: 'Cork', name: 'Cork' },
        { value: 'Donegal', name: 'Donegal' },
        { value: 'Dublin', name: 'Dublin' },
        { value: 'Galway', name: 'Galway' },
        { value: 'Kerry', name: 'Kerry' },
        { value: 'Kildare', name: 'Kildare' },
        { value: 'Kilkenny', name: 'Kilkenny' },
        { value: 'Laois', name: 'Laois' },
        { value: 'Leitrim', name: 'Leitrim' },
        { value: 'Limerick', name: 'Limerick' },
        { value: 'Longford', name: 'Longford' },
        { value: 'Louth', name: 'Louth' },
        { value: 'Mayo', name: 'Mayo' },
        { value: 'Meath', name: 'Meath' },
        { value: 'Monaghan', name: 'Monaghan' },
        { value: 'Offaly', name: 'Offaly' },
        { value: 'Roscommon', name: 'Roscommon' },
        { value: 'Sligo', name: 'Sligo' },
        { value: 'Tipperary', name: 'Tipperary' },
        { value: 'Waterford', name: 'Waterford' },
        { value: 'Westmeath', name: 'Westmeath' },
        { value: 'Wexford', name: 'Wexford' },
        { value: 'Wicklow', name: 'Wicklow' },
    ],
    IL: [
        { value: 'Central', name: 'Central' },
        { value: 'Haifa', name: 'Haifa' },
        { value: 'Jerusalem', name: 'Jerusalem' },
        { value: 'Northern', name: 'Northern' },
        { value: 'Southern', name: 'Southern' },
        { value: 'Tel Aviv', name: 'Tel Aviv' },
    ],
    IT: [
        { value: 'Abruzzo', name: 'Abruzzo' },
        { value: 'Basilicata', name: 'Basilicata' },
        { value: 'Calabria', name: 'Calabria' },
        { value: 'Campania', name: 'Campania' },
        { value: 'Emilia-Romagna', name: 'Emilia-Romagna' },
        { value: 'Friuli-Venezia Giulia', name: 'Friuli-Venezia Giulia' },
        { value: 'Lazio', name: 'Lazio' },
        { value: 'Liguria', name: 'Liguria' },
        { value: 'Lombardia', name: 'Lombardia' },
        { value: 'Marche', name: 'Marche' },
        { value: 'Molise', name: 'Molise' },
        { value: 'Piemonte', name: 'Piemonte' },
        { value: 'Puglia', name: 'Puglia' },
        { value: 'Sardegna', name: 'Sardegna' },
        { value: 'Sicilia', name: 'Sicilia' },
        { value: 'Toscana', name: 'Toscana' },
        { value: 'Trentino-Alto Adige', name: 'Trentino-Alto Adige' },
        { value: 'Umbria', name: 'Umbria' },
        { value: "Valle d'Aosta", name: "Valle d'Aosta" },
        { value: 'Veneto', name: 'Veneto' },
    ],
    JM: [
        { value: 'Clarendon', name: 'Clarendon' },
        { value: 'Hanover', name: 'Hanover' },
        { value: 'Kingston', name: 'Kingston' },
        { value: 'Manchester', name: 'Manchester' },
        { value: 'Portland', name: 'Portland' },
        { value: 'Saint Andrew', name: 'Saint Andrew' },
        { value: 'Saint Ann', name: 'Saint Ann' },
        { value: 'Saint Catherine', name: 'Saint Catherine' },
        { value: 'Saint Elizabeth', name: 'Saint Elizabeth' },
        { value: 'Saint James', name: 'Saint James' },
        { value: 'Saint Mary', name: 'Saint Mary' },
        { value: 'Saint Thomas', name: 'Saint Thomas' },
        { value: 'Trelawny', name: 'Trelawny' },
        { value: 'Westmoreland', name: 'Westmoreland' },
    ],
    JP: [
        { value: 'Aichi', name: 'Aichi' },
        { value: 'Akita', name: 'Akita' },
        { value: 'Aomori', name: 'Aomori' },
        { value: 'Chiba', name: 'Chiba' },
        { value: 'Ehime', name: 'Ehime' },
        { value: 'Fukui', name: 'Fukui' },
        { value: 'Fukuoka', name: 'Fukuoka' },
        { value: 'Fukushima', name: 'Fukushima' },
        { value: 'Gifu', name: 'Gifu' },
        { value: 'Gumma', name: 'Gumma' },
        { value: 'Hiroshima', name: 'Hiroshima' },
        { value: 'Hokkaido', name: 'Hokkaido' },
        { value: 'Hyogo', name: 'Hyogo' },
        { value: 'Ibaraki', name: 'Ibaraki' },
        { value: 'Ishikawa', name: 'Ishikawa' },
        { value: 'Iwate', name: 'Iwate' },
        { value: 'Kagawa', name: 'Kagawa' },
        { value: 'Kagoshima', name: 'Kagoshima' },
        { value: 'Kanagawa', name: 'Kanagawa' },
        { value: 'Kochi', name: 'Kochi' },
        { value: 'Kumamoto', name: 'Kumamoto' },
        { value: 'Kyoto', name: 'Kyoto' },
        { value: 'Mie', name: 'Mie' },
        { value: 'Miyagi', name: 'Miyagi' },
        { value: 'Miyazaki', name: 'Miyazaki' },
        { value: 'Nagano', name: 'Nagano' },
        { value: 'Nagasaki', name: 'Nagasaki' },
        { value: 'Nara', name: 'Nara' },
        { value: 'Niigata', name: 'Niigata' },
        { value: 'Oita', name: 'Oita' },
        { value: 'Okayama', name: 'Okayama' },
        { value: 'Okinawa', name: 'Okinawa' },
        { value: 'Osaka', name: 'Osaka' },
        { value: 'Saga', name: 'Saga' },
        { value: 'Saitama', name: 'Saitama' },
        { value: 'Shiga', name: 'Shiga' },
        { value: 'Shimane', name: 'Shimane' },
        { value: 'Shizuoka', name: 'Shizuoka' },
        { value: 'Tochigi', name: 'Tochigi' },
        { value: 'Tokushima', name: 'Tokushima' },
        { value: 'Tokyo', name: 'Tokyo' },
        { value: 'Tottori', name: 'Tottori' },
        { value: 'Toyama', name: 'Toyama' },
        { value: 'Wakayama', name: 'Wakayama' },
        { value: 'Yamagata', name: 'Yamagata' },
        { value: 'Yamaguchi', name: 'Yamaguchi' },
        { value: 'Yamanashi', name: 'Yamanashi' },
    ],
    JO: [
        { value: 'Ajlun', name: 'Ajlun' },
        { value: "Al 'Aqabah", name: "Al 'Aqabah" },
        { value: "Al Balqa'", name: "Al Balqa'" },
        { value: 'Al Karak', name: 'Al Karak' },
        { value: 'Al Mafraq', name: 'Al Mafraq' },
        { value: "'Amman", name: "'Amman" },
        { value: 'At Tafilah', name: 'At Tafilah' },
        { value: "Az Zarqa'", name: "Az Zarqa'" },
        { value: 'Irbid', name: 'Irbid' },
        { value: 'Jarash', name: 'Jarash' },
        { value: "Ma'an", name: "Ma'an" },
        { value: 'Madaba', name: 'Madaba' },
    ],
    KZ: [
        { value: 'Almaty Oblysy', name: 'Almaty Oblysy' },
        { value: 'Almaty Qalasy', name: 'Almaty Qalasy' },
        { value: 'Aqmola Oblysy', name: 'Aqmola Oblysy' },
        { value: 'Aqtobe Oblysy', name: 'Aqtobe Oblysy' },
        { value: 'Astana Qalasy', name: 'Astana Qalasy' },
        { value: 'Atyrau Oblysy', name: 'Atyrau Oblysy' },
        { value: 'Batys Qazaqstan Oblysy', name: 'Batys Qazaqstan Oblysy' },
        { value: 'Bayqongyr Qalasy', name: 'Bayqongyr Qalasy' },
        { value: 'Mangghystau Oblysy', name: 'Mangghystau Oblysy' },
        { value: 'Ongtustik Qazaqstan Oblysy', name: 'Ongtustik Qazaqstan Oblysy' },
        { value: 'Pavlodar Oblysy', name: 'Pavlodar Oblysy' },
        { value: 'Qaraghandy Oblysy', name: 'Qaraghandy Oblysy' },
        { value: 'Qostanay Oblysy', name: 'Qostanay Oblysy' },
        { value: 'Qyzylorda Oblysy', name: 'Qyzylorda Oblysy' },
        { value: 'Shyghys Qazaqstan Oblysy', name: 'Shyghys Qazaqstan Oblysy' },
        { value: 'Soltustik Qazaqstan Oblysy', name: 'Soltustik Qazaqstan Oblysy' },
        { value: 'Zhambyl Oblysy', name: 'Zhambyl Oblysy' },
    ],
    KE: [
        { value: 'Central', name: 'Central' },
        { value: 'Coast', name: 'Coast' },
        { value: 'Eastern', name: 'Eastern' },
        { value: 'Nairobi Area', name: 'Nairobi Area' },
        { value: 'North Eastern', name: 'North Eastern' },
        { value: 'Nyanza', name: 'Nyanza' },
        { value: 'Rift Valley', name: 'Rift Valley' },
        { value: 'Western', name: 'Western' },
    ],
    KW: [
        { value: 'Al Ahmadi', name: 'Al Ahmadi' },
        { value: 'Al Farwaniyah', name: 'Al Farwaniyah' },
        { value: 'Al Asimah', name: 'Al Asimah' },
        { value: 'Al Jahra', name: 'Al Jahra' },
        { value: 'Hawalli', name: 'Hawalli' },
        { value: 'Mubarak Al-Kabeer', name: 'Mubarak Al-Kabeer' },
    ],
    KG: [
        { value: 'Batken Oblasty', name: 'Batken Oblasty' },
        { value: 'Bishkek Shaary', name: 'Bishkek Shaary' },
        { value: 'Chuy Oblasty', name: 'Chuy Oblasty' },
        { value: 'Jalal-Abad Oblasty', name: 'Jalal-Abad Oblasty' },
        { value: 'Naryn Oblasty', name: 'Naryn Oblasty' },
        { value: 'Osh Oblasty', name: 'Osh Oblasty' },
        { value: 'Talas Oblasty', name: 'Talas Oblasty' },
        { value: 'Ysyk-Kol Oblasty', name: 'Ysyk-Kol Oblasty' },
    ],
    LV: [
        { value: 'Aizkraukles Rajons', name: 'Aizkraukles Rajons' },
        { value: 'Aluksnes Rajons', name: 'Aluksnes Rajons' },
        { value: 'Balvu Rajons', name: 'Balvu Rajons' },
        { value: 'Bauskas Rajons', name: 'Bauskas Rajons' },
        { value: 'Cesu Rajons', name: 'Cesu Rajons' },
        { value: 'Daugavpils', name: 'Daugavpils' },
        { value: 'Daugavpils Rajons', name: 'Daugavpils Rajons' },
        { value: 'Dobeles Rajons', name: 'Dobeles Rajons' },
        { value: 'Gulbenes Rajons', name: 'Gulbenes Rajons' },
        { value: 'Jekabpils Rajons', name: 'Jekabpils Rajons' },
        { value: 'Jelgava', name: 'Jelgava' },
        { value: 'Jelgavas Rajons', name: 'Jelgavas Rajons' },
        { value: 'Jurmala', name: 'Jurmala' },
        { value: 'Kraslavas Rajons', name: 'Kraslavas Rajons' },
        { value: 'Kuldigas Rajons', name: 'Kuldigas Rajons' },
        { value: 'Liepaja', name: 'Liepaja' },
        { value: 'Liepajas Rajons', name: 'Liepajas Rajons' },
        { value: 'Limbazu Rajons', name: 'Limbazu Rajons' },
        { value: 'Ludzas Rajons', name: 'Ludzas Rajons' },
        { value: 'Madonas Rajons', name: 'Madonas Rajons' },
        { value: 'Ogres Rajons', name: 'Ogres Rajons' },
        { value: 'Preilu Rajons', name: 'Preilu Rajons' },
        { value: 'Rezekne', name: 'Rezekne' },
        { value: 'Rezeknes Rajons', name: 'Rezeknes Rajons' },
        { value: 'Riga', name: 'Riga' },
        { value: 'Rigas Rajons', name: 'Rigas Rajons' },
        { value: 'Saldus Rajons', name: 'Saldus Rajons' },
        { value: 'Talsu Rajons', name: 'Talsu Rajons' },
        { value: 'Tukuma Rajons', name: 'Tukuma Rajons' },
        { value: 'Valkas Rajons', name: 'Valkas Rajons' },
        { value: 'Valmieras Rajons', name: 'Valmieras Rajons' },
        { value: 'Ventspils', name: 'Ventspils' },
        { value: 'Ventspils Rajons', name: 'Ventspils Rajons' },
    ],
    LT: [
        { value: 'Alytaus', name: 'Alytaus' },
        { value: 'Kauno', name: 'Kauno' },
        { value: 'Klaipedos', name: 'Klaipedos' },
        { value: 'Marijampoles', name: 'Marijampoles' },
        { value: 'Panevezio', name: 'Panevezio' },
        { value: 'Siauliu', name: 'Siauliu' },
        { value: 'Taurages', name: 'Taurages' },
        { value: 'Telsiu', name: 'Telsiu' },
        { value: 'Utenos', name: 'Utenos' },
        { value: 'Vilniaus', name: 'Vilniaus' },
    ],
    LU: [
        { value: 'Diekirch', name: 'Diekirch' },
        { value: 'Grevenmacher', name: 'Grevenmacher' },
        { value: 'Luxembourg', name: 'Luxembourg' },
    ],
    MY: [
        { value: 'Johor', name: 'Johor' },
        { value: 'Kedah', name: 'Kedah' },
        { value: 'Kelantan', name: 'Kelantan' },
        { value: 'Kuala Lumpur', name: 'Kuala Lumpur' },
        { value: 'Labuan', name: 'Labuan' },
        { value: 'Malacca', name: 'Malacca' },
        { value: 'Negeri Sembilan', name: 'Negeri Sembilan' },
        { value: 'Pahang', name: 'Pahang' },
        { value: 'Perak', name: 'Perak' },
        { value: 'Perlis', name: 'Perlis' },
        { value: 'Penang', name: 'Penang' },
        { value: 'Sabah', name: 'Sabah' },
        { value: 'Sarawak', name: 'Sarawak' },
        { value: 'Selangor', name: 'Selangor' },
        { value: 'Terengganu', name: 'Terengganu' },
    ],
    MX: [
        { value: 'Aguascalientes', name: 'Aguascalientes' },
        { value: 'Baja California', name: 'Baja California' },
        { value: 'Baja California Sur', name: 'Baja California Sur' },
        { value: 'Campeche', name: 'Campeche' },
        { value: 'Chiapas', name: 'Chiapas' },
        { value: 'Chihuahua', name: 'Chihuahua' },
        { value: 'Coahuila de Zaragoza', name: 'Coahuila de Zaragoza' },
        { value: 'Colima', name: 'Colima' },
        { value: 'Distrito Federal', name: 'Distrito Federal' },
        { value: 'Durango', name: 'Durango' },
        { value: 'Guanajuato', name: 'Guanajuato' },
        { value: 'Guerrero', name: 'Guerrero' },
        { value: 'Hidalgo', name: 'Hidalgo' },
        { value: 'Jalisco', name: 'Jalisco' },
        { value: 'Mexico', name: 'Mexico' },
        { value: 'Michoacan de Ocampo', name: 'Michoacan de Ocampo' },
        { value: 'Morelos', name: 'Morelos' },
        { value: 'Nayarit', name: 'Nayarit' },
        { value: 'Nuevo Leon', name: 'Nuevo Leon' },
        { value: 'Oaxaca', name: 'Oaxaca' },
        { value: 'Puebla', name: 'Puebla' },
        { value: 'Queretaro de Arteaga', name: 'Queretaro de Arteaga' },
        { value: 'Quintana Roo', name: 'Quintana Roo' },
        { value: 'San Luis Potosi', name: 'San Luis Potosi' },
        { value: 'Sinaloa', name: 'Sinaloa' },
        { value: 'Sonora', name: 'Sonora' },
        { value: 'Tabasco', name: 'Tabasco' },
        { value: 'Tamaulipas', name: 'Tamaulipas' },
        { value: 'Tlaxcala', name: 'Tlaxcala' },
        { value: 'Veracruz-Llave', name: 'Veracruz-Llave' },
        { value: 'Yucatan', name: 'Yucatan' },
        { value: 'Zacatecas', name: 'Zacatecas' },
    ],
    NL: [
        { value: 'Drenthe', name: 'Drenthe' },
        { value: 'Flevoland', name: 'Flevoland' },
        { value: 'Friesland', name: 'Friesland' },
        { value: 'Gelderland', name: 'Gelderland' },
        { value: 'Groningen', name: 'Groningen' },
        { value: 'Limburg', name: 'Limburg' },
        { value: 'Noord-Brabant', name: 'Noord-Brabant' },
        { value: 'Noord-Holland', name: 'Noord-Holland' },
        { value: 'Overijssel', name: 'Overijssel' },
        { value: 'Utrecht', name: 'Utrecht' },
        { value: 'Zeeland', name: 'Zeeland' },
        { value: 'Zuid-Holland', name: 'Zuid-Holland' },
    ],
    NZ: [
        { value: 'Auckland', name: 'Auckland' },
        { value: 'Bay of Plenty', name: 'Bay of Plenty' },
        { value: 'Canterbury', name: 'Canterbury' },
        { value: 'Chatham Islands', name: 'Chatham Islands' },
        { value: 'Gisborne', name: 'Gisborne' },
        { value: "Hawke's Bay", name: "Hawke's Bay" },
        { value: 'Manawatu-Wanganui', name: 'Manawatu-Wanganui' },
        { value: 'Marlborough', name: 'Marlborough' },
        { value: 'Nelson', name: 'Nelson' },
        { value: 'Northland', name: 'Northland' },
        { value: 'Otago', name: 'Otago' },
        { value: 'Southland', name: 'Southland' },
        { value: 'Taranaki', name: 'Taranaki' },
        { value: 'Tasman', name: 'Tasman' },
        { value: 'Waikato', name: 'Waikato' },
        { value: 'Wellington', name: 'Wellington' },
        { value: 'West Coast', name: 'West Coast' },
    ],
    NO: [
        { value: 'Akershus', name: 'Akershus' },
        { value: 'Aust-Agder', name: 'Aust-Agder' },
        { value: 'Buskerud', name: 'Buskerud' },
        { value: 'Finnmark', name: 'Finnmark' },
        { value: 'Hedmark', name: 'Hedmark' },
        { value: 'Hordaland', name: 'Hordaland' },
        { value: 'More og Romsdal', name: 'More og Romsdal' },
        { value: 'Nordland', name: 'Nordland' },
        { value: 'Nord-Trondelag', name: 'Nord-Trondelag' },
        { value: 'Oppland', name: 'Oppland' },
        { value: 'Oslo', name: 'Oslo' },
        { value: 'Ostfold', name: 'Ostfold' },
        { value: 'Rogaland', name: 'Rogaland' },
        { value: 'Sogn og Fjordane', name: 'Sogn og Fjordane' },
        { value: 'Sor-Trondelag', name: 'Sor-Trondelag' },
        { value: 'Telemark', name: 'Telemark' },
        { value: 'Troms', name: 'Troms' },
        { value: 'Vest-Agder', name: 'Vest-Agder' },
        { value: 'Vestfold', name: 'Vestfold' },
    ],
    PK: [
        { value: 'Balochistan', name: 'Balochistan' },
        { value: 'North-West Frontier Province', name: 'North-West Frontier Province' },
        { value: 'Punjab', name: 'Punjab' },
        { value: 'Sindh', name: 'Sindh' },
        { value: 'Islamabad Capital Territory', name: 'Islamabad Capital Territory' },
        {
            value: 'Federally Administered Tribal Areas',
            name: 'Federally Administered Tribal Areas',
        },
    ],
    PA: [
        { value: 'Bocas del Toro', name: 'Bocas del Toro' },
        { value: 'Chiriqui', name: 'Chiriqui' },
        { value: 'Cocle', name: 'Cocle' },
        { value: 'Colon', name: 'Colon' },
        { value: 'Darien', name: 'Darien' },
        { value: 'Herrera', name: 'Herrera' },
        { value: 'Los Santos', name: 'Los Santos' },
        { value: 'Panama', name: 'Panama' },
        { value: 'San Blas', name: 'San Blas' },
        { value: 'Veraguas', name: 'Veraguas' },
    ],
    PG: [
        { value: 'Bougainville', name: 'Bougainville' },
        { value: 'Central', name: 'Central' },
        { value: 'Chimbu', name: 'Chimbu' },
        { value: 'Eastern Highlands', name: 'Eastern Highlands' },
        { value: 'East New Britain', name: 'East New Britain' },
        { value: 'East Sepik', name: 'East Sepik' },
        { value: 'Enga', name: 'Enga' },
        { value: 'Gulf', name: 'Gulf' },
        { value: 'Madang', name: 'Madang' },
        { value: 'Manus', name: 'Manus' },
        { value: 'Milne Bay', name: 'Milne Bay' },
        { value: 'Morobe', name: 'Morobe' },
        { value: 'National Capital', name: 'National Capital' },
        { value: 'New Ireland', name: 'New Ireland' },
        { value: 'Northern', name: 'Northern' },
        { value: 'Sandaun', name: 'Sandaun' },
        { value: 'Southern Highlands', name: 'Southern Highlands' },
        { value: 'Western', name: 'Western' },
        { value: 'Western Highlands', name: 'Western Highlands' },
        { value: 'West New Britain', name: 'West New Britain' },
    ],
    PY: [
        { value: 'Alto Paraguay', name: 'Alto Paraguay' },
        { value: 'Alto Parana', name: 'Alto Parana' },
        { value: 'Amambay', name: 'Amambay' },
        { value: 'Asuncion', name: 'Asuncion' },
        { value: 'Boqueron', name: 'Boqueron' },
        { value: 'Caaguazu', name: 'Caaguazu' },
        { value: 'Caazapa', name: 'Caazapa' },
        { value: 'Canindeyu', name: 'Canindeyu' },
        { value: 'Central', name: 'Central' },
        { value: 'Concepcion', name: 'Concepcion' },
        { value: 'Cordillera', name: 'Cordillera' },
        { value: 'Guaira', name: 'Guaira' },
        { value: 'Itapua', name: 'Itapua' },
        { value: 'Misiones', name: 'Misiones' },
        { value: 'Neembucu', name: 'Neembucu' },
        { value: 'Paraguari', name: 'Paraguari' },
        { value: 'Presidente Hayes', name: 'Presidente Hayes' },
        { value: 'San Pedro', name: 'San Pedro' },
    ],
    PE: [
        { value: 'Amazonas', name: 'Amazonas' },
        { value: 'Ancash', name: 'Ancash' },
        { value: 'Apurimac', name: 'Apurimac' },
        { value: 'Arequipa', name: 'Arequipa' },
        { value: 'Ayacucho', name: 'Ayacucho' },
        { value: 'Cajamarca', name: 'Cajamarca' },
        { value: 'Callao', name: 'Callao' },
        { value: 'Cusco', name: 'Cusco' },
        { value: 'Huancavelica', name: 'Huancavelica' },
        { value: 'Huanuco', name: 'Huanuco' },
        { value: 'Ica', name: 'Ica' },
        { value: 'Junin', name: 'Junin' },
        { value: 'La Libertad', name: 'La Libertad' },
        { value: 'Lambayeque', name: 'Lambayeque' },
        { value: 'Lima', name: 'Lima' },
        { value: 'Loreto', name: 'Loreto' },
        { value: 'Madre de Dios', name: 'Madre de Dios' },
        { value: 'Moquegua', name: 'Moquegua' },
        { value: 'Pasco', name: 'Pasco' },
        { value: 'Piura', name: 'Piura' },
        { value: 'Puno', name: 'Puno' },
        { value: 'San Martin', name: 'San Martin' },
        { value: 'Tacna', name: 'Tacna' },
        { value: 'Tumbes', name: 'Tumbes' },
        { value: 'Ucayali', name: 'Ucayali' },
    ],
    PH: [
        { value: 'Abra', name: 'Abra' },
        { value: 'Agusan del Norte', name: 'Agusan del Norte' },
        { value: 'Agusan del Sur', name: 'Agusan del Sur' },
        { value: 'Aklan', name: 'Aklan' },
        { value: 'Albay', name: 'Albay' },
        { value: 'Antique', name: 'Antique' },
        { value: 'Apayao', name: 'Apayao' },
        { value: 'Aurora', name: 'Aurora' },
        { value: 'Basilan', name: 'Basilan' },
        { value: 'Bataan', name: 'Bataan' },
        { value: 'Batanes', name: 'Batanes' },
        { value: 'Batangas', name: 'Batangas' },
        { value: 'Biliran', name: 'Biliran' },
        { value: 'Benguet', name: 'Benguet' },
        { value: 'Bohol', name: 'Bohol' },
        { value: 'Bukidnon', name: 'Bukidnon' },
        { value: 'Bulacan', name: 'Bulacan' },
        { value: 'Cagayan', name: 'Cagayan' },
        { value: 'Camarines Norte', name: 'Camarines Norte' },
        { value: 'Camarines Sur', name: 'Camarines Sur' },
        { value: 'Camiguin', name: 'Camiguin' },
        { value: 'Capiz', name: 'Capiz' },
        { value: 'Catanduanes', name: 'Catanduanes' },
        { value: 'Cavite', name: 'Cavite' },
        { value: 'Cebu', name: 'Cebu' },
        { value: 'Compostela', name: 'Compostela' },
        { value: 'Davao del Norte', name: 'Davao del Norte' },
        { value: 'Davao del Sur', name: 'Davao del Sur' },
        { value: 'Davao Oriental', name: 'Davao Oriental' },
        { value: 'Eastern Samar', name: 'Eastern Samar' },
        { value: 'Guimaras', name: 'Guimaras' },
        { value: 'Ifugao', name: 'Ifugao' },
        { value: 'Ilocos Norte', name: 'Ilocos Norte' },
        { value: 'Ilocos Sur', name: 'Ilocos Sur' },
        { value: 'Iloilo', name: 'Iloilo' },
        { value: 'Isabela', name: 'Isabela' },
        { value: 'Kalinga', name: 'Kalinga' },
        { value: 'Laguna', name: 'Laguna' },
        { value: 'Lanao del Norte', name: 'Lanao del Norte' },
        { value: 'Lanao del Sur', name: 'Lanao del Sur' },
        { value: 'La Union', name: 'La Union' },
        { value: 'Leyte', name: 'Leyte' },
        { value: 'Maguindanao', name: 'Maguindanao' },
        { value: 'Marinduque', name: 'Marinduque' },
        { value: 'Masbate', name: 'Masbate' },
        { value: 'Mindoro Occidental', name: 'Mindoro Occidental' },
        { value: 'Mindoro Oriental', name: 'Mindoro Oriental' },
        { value: 'Misamis Occidental', name: 'Misamis Occidental' },
        { value: 'Misamis Oriental', name: 'Misamis Oriental' },
        { value: 'Mountain Province', name: 'Mountain Province' },
        { value: 'Negros Occidental', name: 'Negros Occidental' },
        { value: 'Negros Oriental', name: 'Negros Oriental' },
        { value: 'North Cotabato', name: 'North Cotabato' },
        { value: 'Northern Samar', name: 'Northern Samar' },
        { value: 'Nueva Ecija', name: 'Nueva Ecija' },
        { value: 'Nueva Vizcaya', name: 'Nueva Vizcaya' },
        { value: 'Palawan', name: 'Palawan' },
        { value: 'Pampanga', name: 'Pampanga' },
        { value: 'Pangasinan', name: 'Pangasinan' },
        { value: 'Quezon', name: 'Quezon' },
        { value: 'Quirino', name: 'Quirino' },
        { value: 'Rizal', name: 'Rizal' },
        { value: 'Romblon', name: 'Romblon' },
        { value: 'Samar', name: 'Samar' },
        { value: 'Sarangani', name: 'Sarangani' },
        { value: 'Siquijor', name: 'Siquijor' },
        { value: 'Sorsogon', name: 'Sorsogon' },
        { value: 'South Cotabato', name: 'South Cotabato' },
        { value: 'Southern Leyte', name: 'Southern Leyte' },
        { value: 'Sultan Kudarat', name: 'Sultan Kudarat' },
        { value: 'Sulu', name: 'Sulu' },
        { value: 'Surigao del Norte', name: 'Surigao del Norte' },
        { value: 'Surigao del Sur', name: 'Surigao del Sur' },
        { value: 'Tarlac', name: 'Tarlac' },
        { value: 'Tawi-Tawi', name: 'Tawi-Tawi' },
        { value: 'Zambales', name: 'Zambales' },
        { value: 'Zamboanga del Norte', name: 'Zamboanga del Norte' },
        { value: 'Zamboanga del Sur', name: 'Zamboanga del Sur' },
        { value: 'Zamboanga Sibugay', name: 'Zamboanga Sibugay' },
    ],
    PL: [
        { value: 'Greater Poland (Wielkopolskie)', name: 'Greater Poland (Wielkopolskie)' },
        {
            value: 'Kuyavian-Pomeranian (Kujawsko-Pomorskie)',
            name: 'Kuyavian-Pomeranian (Kujawsko-Pomorskie)',
        },
        { value: 'Lesser Poland (Malopolskie)', name: 'Lesser Poland (Malopolskie)' },
        { value: 'Lodz (Lodzkie)', name: 'Lodz (Lodzkie)' },
        { value: 'Lower Silesian (Dolnoslaskie)', name: 'Lower Silesian (Dolnoslaskie)' },
        { value: 'Lublin (Lubelskie)', name: 'Lublin (Lubelskie)' },
        { value: 'Lubusz (Lubuskie)', name: 'Lubusz (Lubuskie)' },
        { value: 'Masovian (Mazowieckie)', name: 'Masovian (Mazowieckie)' },
        { value: 'Opole (Opolskie)', name: 'Opole (Opolskie)' },
        { value: 'Podlasie (Podlaskie)', name: 'Podlasie (Podlaskie)' },
        { value: 'Pomeranian (Pomorskie)', name: 'Pomeranian (Pomorskie)' },
        { value: 'Silesian (Slaskie)', name: 'Silesian (Slaskie)' },
        { value: 'Subcarpathian (Podkarpackie)', name: 'Subcarpathian (Podkarpackie)' },
        { value: 'Swietokrzyskie (Swietokrzyskie)', name: 'Swietokrzyskie (Swietokrzyskie)' },
        {
            value: 'Warmian-Masurian (Warminsko-Mazurskie)',
            name: 'Warmian-Masurian (Warminsko-Mazurskie)',
        },
        {
            value: 'West Pomeranian (Zachodniopomorskie)',
            name: 'West Pomeranian (Zachodniopomorskie)',
        },
    ],
    PT: [
        { value: 'Aveiro', name: 'Aveiro' },
        { value: 'Acores', name: 'Acores' },
        { value: 'Beja', name: 'Beja' },
        { value: 'Braga', name: 'Braga' },
        { value: 'Braganca', name: 'Braganca' },
        { value: 'Castelo Branco', name: 'Castelo Branco' },
        { value: 'Coimbra', name: 'Coimbra' },
        { value: 'Evora', name: 'Evora' },
        { value: 'Faro', name: 'Faro' },
        { value: 'Guarda', name: 'Guarda' },
        { value: 'Leiria', name: 'Leiria' },
        { value: 'Lisboa', name: 'Lisboa' },
        { value: 'Madeira', name: 'Madeira' },
        { value: 'Portalegre', name: 'Portalegre' },
        { value: 'Porto', name: 'Porto' },
        { value: 'Santarem', name: 'Santarem' },
        { value: 'Setubal', name: 'Setubal' },
        { value: 'Viana do Castelo', name: 'Viana do Castelo' },
        { value: 'Vila Real', name: 'Vila Real' },
        { value: 'Viseu', name: 'Viseu' },
    ],
    QA: [
        { value: 'Ad Dawhah', name: 'Ad Dawhah' },
        { value: 'Al Ghuwayriyah', name: 'Al Ghuwayriyah' },
        { value: 'Al Jumayliyah', name: 'Al Jumayliyah' },
        { value: 'Al Khawr', name: 'Al Khawr' },
        { value: 'Al Wakrah', name: 'Al Wakrah' },
        { value: 'Ar Rayyan', name: 'Ar Rayyan' },
        { value: 'Jarayan al Batinah', name: 'Jarayan al Batinah' },
        { value: 'Madinat ash Shamal', name: 'Madinat ash Shamal' },
        { value: "Umm Sa'id", name: "Umm Sa'id" },
        { value: 'Umm Salal', name: 'Umm Salal' },
    ],
    RO: [
        { value: 'Alba', name: 'Alba' },
        { value: 'Arad', name: 'Arad' },
        { value: 'Arges', name: 'Arges' },
        { value: 'Bacau', name: 'Bacau' },
        { value: 'Bihor', name: 'Bihor' },
        { value: 'Bistrita-Nasaud', name: 'Bistrita-Nasaud' },
        { value: 'Botosani', name: 'Botosani' },
        { value: 'Braila', name: 'Braila' },
        { value: 'Brasov', name: 'Brasov' },
        { value: 'Bucuresti', name: 'Bucuresti' },
        { value: 'Buzau', name: 'Buzau' },
        { value: 'Calarasi', name: 'Calarasi' },
        { value: 'Caras-Severin', name: 'Caras-Severin' },
        { value: 'Cluj', name: 'Cluj' },
        { value: 'Constanta', name: 'Constanta' },
        { value: 'Covasna', name: 'Covasna' },
        { value: 'Dimbovita', name: 'Dimbovita' },
        { value: 'Dolj', name: 'Dolj' },
        { value: 'Galati', name: 'Galati' },
        { value: 'Gorj', name: 'Gorj' },
        { value: 'Giurgiu', name: 'Giurgiu' },
        { value: 'Harghita', name: 'Harghita' },
        { value: 'Hunedoara', name: 'Hunedoara' },
        { value: 'Ialomita', name: 'Ialomita' },
        { value: 'Iasi', name: 'Iasi' },
        { value: 'Ilfov', name: 'Ilfov' },
        { value: 'Maramures', name: 'Maramures' },
        { value: 'Mehedinti', name: 'Mehedinti' },
        { value: 'Mures', name: 'Mures' },
        { value: 'Neamt', name: 'Neamt' },
        { value: 'Olt', name: 'Olt' },
        { value: 'Prahova', name: 'Prahova' },
        { value: 'Salaj', name: 'Salaj' },
        { value: 'Satu Mare', name: 'Satu Mare' },
        { value: 'Sibiu', name: 'Sibiu' },
        { value: 'Suceava', name: 'Suceava' },
        { value: 'Teleorman', name: 'Teleorman' },
        { value: 'Timis', name: 'Timis' },
        { value: 'Tulcea', name: 'Tulcea' },
        { value: 'Vaslui', name: 'Vaslui' },
        { value: 'Vilcea', name: 'Vilcea' },
        { value: 'Vrancea', name: 'Vrancea' },
    ],
    RU: [
        { value: 'Amur', name: 'Amur' },
        { value: "Arkhangel'sk", name: "Arkhangel'sk" },
        { value: "Astrakhan'", name: "Astrakhan'" },
        { value: 'Belgorod', name: 'Belgorod' },
        { value: 'Bryansk', name: 'Bryansk' },
        { value: 'Chelyabinsk', name: 'Chelyabinsk' },
        { value: 'Chita', name: 'Chita' },
        { value: 'Irkutsk', name: 'Irkutsk' },
        { value: 'Ivanovo', name: 'Ivanovo' },
        { value: 'Kaliningrad', name: 'Kaliningrad' },
        { value: 'Kaluga', name: 'Kaluga' },
        { value: 'Kamchatka', name: 'Kamchatka' },
        { value: 'Kemerovo', name: 'Kemerovo' },
        { value: 'Kirov', name: 'Kirov' },
        { value: 'Kostroma', name: 'Kostroma' },
        { value: 'Kurgan', name: 'Kurgan' },
        { value: 'Kursk', name: 'Kursk' },
        { value: 'Leningrad', name: 'Leningrad' },
        { value: 'Lipetsk', name: 'Lipetsk' },
        { value: 'Magadan', name: 'Magadan' },
        { value: 'Moscow', name: 'Moscow' },
        { value: 'Murmansk', name: 'Murmansk' },
        { value: 'Nizhniy Novgorod', name: 'Nizhniy Novgorod' },
        { value: 'Novgorod', name: 'Novgorod' },
        { value: 'Novosibirsk', name: 'Novosibirsk' },
        { value: 'Omsk', name: 'Omsk' },
        { value: 'Orenburg', name: 'Orenburg' },
        { value: 'Orel', name: 'Orel' },
        { value: 'Penza', name: 'Penza' },
        { value: "Perm'", name: "Perm'" },
        { value: 'Pskov', name: 'Pskov' },
        { value: 'Rostov', name: 'Rostov' },
        { value: "Ryazan'", name: "Ryazan'" },
        { value: 'Sakhalin', name: 'Sakhalin' },
        { value: 'Samara', name: 'Samara' },
        { value: 'Saratov', name: 'Saratov' },
        { value: 'Smolensk', name: 'Smolensk' },
        { value: 'Sverdlovsk', name: 'Sverdlovsk' },
        { value: 'Tambov', name: 'Tambov' },
        { value: 'Tomsk', name: 'Tomsk' },
        { value: 'Tula', name: 'Tula' },
        { value: "Tver'", name: "Tver'" },
        { value: "Tyumen'", name: "Tyumen'" },
        { value: "Ul'yanovsk", name: "Ul'yanovsk" },
        { value: 'Vladimir', name: 'Vladimir' },
        { value: 'Volgograd', name: 'Volgograd' },
        { value: 'Vologda', name: 'Vologda' },
        { value: 'Voronezh', name: 'Voronezh' },
        { value: "Yaroslavl'", name: "Yaroslavl'" },
        { value: 'Adygeya', name: 'Adygeya' },
        { value: 'Altay', name: 'Altay' },
        { value: 'Bashkortostan', name: 'Bashkortostan' },
        { value: 'Buryatiya', name: 'Buryatiya' },
        { value: 'Chechnya', name: 'Chechnya' },
        { value: 'Chuvashiya', name: 'Chuvashiya' },
        { value: 'Dagestan', name: 'Dagestan' },
        { value: 'Ingushetiya', name: 'Ingushetiya' },
        { value: 'Kabardino-Balkariya', name: 'Kabardino-Balkariya' },
        { value: 'Kalmykiya', name: 'Kalmykiya' },
        { value: 'Karachayevo-Cherkesiya', name: 'Karachayevo-Cherkesiya' },
        { value: 'Kareliya', name: 'Kareliya' },
        { value: 'Khakasiya', name: 'Khakasiya' },
        { value: 'Komi', name: 'Komi' },
        { value: 'Mariy-El', name: 'Mariy-El' },
        { value: 'Mordoviya', name: 'Mordoviya' },
        { value: 'Sakha', name: 'Sakha' },
        { value: 'North Ossetia', name: 'North Ossetia' },
        { value: 'Tatarstan', name: 'Tatarstan' },
        { value: 'Tyva', name: 'Tyva' },
        { value: 'Udmurtiya', name: 'Udmurtiya' },
        { value: 'Aga Buryat', name: 'Aga Buryat' },
        { value: 'Chukotka', name: 'Chukotka' },
        { value: 'Evenk', name: 'Evenk' },
        { value: 'Khanty-Mansi', name: 'Khanty-Mansi' },
        { value: 'Komi-Permyak', name: 'Komi-Permyak' },
        { value: 'Koryak', name: 'Koryak' },
        { value: 'Nenets', name: 'Nenets' },
        { value: 'Taymyr', name: 'Taymyr' },
        { value: "Ust'-Orda Buryat", name: "Ust'-Orda Buryat" },
        { value: 'Yamalo-Nenets', name: 'Yamalo-Nenets' },
        { value: 'Altay', name: 'Altay' },
        { value: 'Khabarovsk', name: 'Khabarovsk' },
        { value: 'Krasnodar', name: 'Krasnodar' },
        { value: 'Krasnoyarsk', name: 'Krasnoyarsk' },
        { value: 'Primorskiy', name: 'Primorskiy' },
        { value: "Stavropol'", name: "Stavropol'" },
        { value: 'Moscow', name: 'Moscow' },
        { value: 'St. Petersburg', name: 'St. Petersburg' },
        { value: 'Yevrey', name: 'Yevrey' },
    ],
    RW: [
        { value: 'Butare', name: 'Butare' },
        { value: 'Byumba', name: 'Byumba' },
        { value: 'Cyangugu', name: 'Cyangugu' },
        { value: 'Gikongoro', name: 'Gikongoro' },
        { value: 'Gisenyi', name: 'Gisenyi' },
        { value: 'Gitarama', name: 'Gitarama' },
        { value: 'Kibungo', name: 'Kibungo' },
        { value: 'Kibuye', name: 'Kibuye' },
        { value: 'Kigali Rurale', name: 'Kigali Rurale' },
        { value: 'Kigali-ville', name: 'Kigali-ville' },
        { value: 'Umutara', name: 'Umutara' },
        { value: 'Ruhengeri', name: 'Ruhengeri' },
    ],
    WS: [
        { value: "A'ana", name: "A'ana" },
        { value: 'Aiga-i-le-Tai', name: 'Aiga-i-le-Tai' },
        { value: 'Atua', name: 'Atua' },
        { value: "Fa'asaleleaga", name: "Fa'asaleleaga" },
        { value: "Gaga'emauga", name: "Gaga'emauga" },
        { value: 'Gagaifomauga', name: 'Gagaifomauga' },
        { value: 'Palauli', name: 'Palauli' },
        { value: "Satupa'itea", name: "Satupa'itea" },
        { value: 'Tuamasaga', name: 'Tuamasaga' },
        { value: "Va'a-o-Fonoti", name: "Va'a-o-Fonoti" },
        { value: 'Vaisigano', name: 'Vaisigano' },
    ],
    SM: [
        { value: 'Acquaviva', name: 'Acquaviva' },
        { value: 'Borgo Maggiore', name: 'Borgo Maggiore' },
        { value: 'Chiesanuova', name: 'Chiesanuova' },
        { value: 'Domagnano', name: 'Domagnano' },
        { value: 'Faetano', name: 'Faetano' },
        { value: 'Fiorentino', name: 'Fiorentino' },
        { value: 'Montegiardino', name: 'Montegiardino' },
        { value: 'San Marino Citta', name: 'San Marino Citta' },
        { value: 'Serravalle', name: 'Serravalle' },
    ],
    SA: [
        { value: 'Al Bahah', name: 'Al Bahah' },
        { value: 'Al Hudud ash Shamaliyah', name: 'Al Hudud ash Shamaliyah' },
        { value: 'Al Jawf', name: 'Al Jawf' },
        { value: 'Al Madinah', name: 'Al Madinah' },
        { value: 'Al Qasim', name: 'Al Qasim' },
        { value: 'Ar Riyad', name: 'Ar Riyad' },
        { value: 'Ash Sharqiyah', name: 'Ash Sharqiyah' },
        { value: "'Asir", name: "'Asir" },
        { value: "Ha'il", name: "Ha'il" },
        { value: 'Jizan', name: 'Jizan' },
        { value: 'Makkah', name: 'Makkah' },
        { value: 'Najran', name: 'Najran' },
        { value: 'Tabuk', name: 'Tabuk' },
    ],
    SN: [
        { value: 'Dakar', name: 'Dakar' },
        { value: 'Diourbel', name: 'Diourbel' },
        { value: 'Fatick', name: 'Fatick' },
        { value: 'Kaolack', name: 'Kaolack' },
        { value: 'Kolda', name: 'Kolda' },
        { value: 'Louga', name: 'Louga' },
        { value: 'Matam', name: 'Matam' },
        { value: 'Saint-Louis', name: 'Saint-Louis' },
        { value: 'Tambacounda', name: 'Tambacounda' },
        { value: 'Thies', name: 'Thies' },
        { value: 'Ziguinchor', name: 'Ziguinchor' },
    ],
    SC: [
        { value: 'Anse aux Pins', name: 'Anse aux Pins' },
        { value: 'Anse Boileau', name: 'Anse Boileau' },
        { value: 'Anse Etoile', name: 'Anse Etoile' },
        { value: 'Anse Louis', name: 'Anse Louis' },
        { value: 'Anse Royale', name: 'Anse Royale' },
        { value: 'Baie Lazare', name: 'Baie Lazare' },
        { value: 'Baie Sainte Anne', name: 'Baie Sainte Anne' },
        { value: 'Beau Vallon', name: 'Beau Vallon' },
        { value: 'Bel Air', name: 'Bel Air' },
        { value: 'Bel Ombre', name: 'Bel Ombre' },
        { value: 'Cascade', name: 'Cascade' },
        { value: 'Glacis', name: 'Glacis' },
        { value: "Grand' Anse", name: "Grand' Anse" },
        { value: "Grand' Anse", name: "Grand' Anse" },
        { value: 'La Digue', name: 'La Digue' },
        { value: 'La Riviere Anglaise', name: 'La Riviere Anglaise' },
        { value: 'Mont Buxton', name: 'Mont Buxton' },
        { value: 'Mont Fleuri', name: 'Mont Fleuri' },
        { value: 'Plaisance', name: 'Plaisance' },
        { value: 'Pointe La Rue', name: 'Pointe La Rue' },
        { value: 'Port Glaud', name: 'Port Glaud' },
        { value: 'Saint Louis', name: 'Saint Louis' },
        { value: 'Takamaka', name: 'Takamaka' },
    ],
    SK: [
        { value: 'Banskobystricky', name: 'Banskobystricky' },
        { value: 'Bratislavsky', name: 'Bratislavsky' },
        { value: 'Kosicky', name: 'Kosicky' },
        { value: 'Nitriansky', name: 'Nitriansky' },
        { value: 'Presovsky', name: 'Presovsky' },
        { value: 'Trenciansky', name: 'Trenciansky' },
        { value: 'Trnavsky', name: 'Trnavsky' },
        { value: 'Zilinsky', name: 'Zilinsky' },
    ],
    SI: [
        { value: 'Ajdovscina', name: 'Ajdovscina' },
        { value: 'Beltinci', name: 'Beltinci' },
        { value: 'Benedikt', name: 'Benedikt' },
        { value: 'Bistrica ob Sotli', name: 'Bistrica ob Sotli' },
        { value: 'Bled', name: 'Bled' },
        { value: 'Bloke', name: 'Bloke' },
        { value: 'Bohinj', name: 'Bohinj' },
        { value: 'Borovnica', name: 'Borovnica' },
        { value: 'Bovec', name: 'Bovec' },
        { value: 'Braslovce', name: 'Braslovce' },
        { value: 'Brda', name: 'Brda' },
        { value: 'Brezice', name: 'Brezice' },
        { value: 'Brezovica', name: 'Brezovica' },
        { value: 'Cankova', name: 'Cankova' },
        { value: 'Celje', name: 'Celje' },
        { value: 'Cerklje na Gorenjskem', name: 'Cerklje na Gorenjskem' },
        { value: 'Cerknica', name: 'Cerknica' },
        { value: 'Cerkno', name: 'Cerkno' },
        { value: 'Cerkvenjak', name: 'Cerkvenjak' },
        { value: 'Crensovci', name: 'Crensovci' },
        { value: 'Crna na Koroskem', name: 'Crna na Koroskem' },
        { value: 'Crnomelj', name: 'Crnomelj' },
        { value: 'Destrnik', name: 'Destrnik' },
        { value: 'Divaca', name: 'Divaca' },
        { value: 'Dobje', name: 'Dobje' },
        { value: 'Dobrepolje', name: 'Dobrepolje' },
        { value: 'Dobrna', name: 'Dobrna' },
        { value: 'Dobrova-Horjul-Polhov Gradec', name: 'Dobrova-Horjul-Polhov Gradec' },
        { value: 'Dobrovnik-Dobronak', name: 'Dobrovnik-Dobronak' },
        { value: 'Dolenjske Toplice', name: 'Dolenjske Toplice' },
        { value: 'Dol pri Ljubljani', name: 'Dol pri Ljubljani' },
        { value: 'Domzale', name: 'Domzale' },
        { value: 'Dornava', name: 'Dornava' },
        { value: 'Dravograd', name: 'Dravograd' },
        { value: 'Duplek', name: 'Duplek' },
        { value: 'Gorenja Vas-Poljane', name: 'Gorenja Vas-Poljane' },
        { value: 'Gorisnica', name: 'Gorisnica' },
        { value: 'Gornja Radgona', name: 'Gornja Radgona' },
        { value: 'Gornji Grad', name: 'Gornji Grad' },
        { value: 'Gornji Petrovci', name: 'Gornji Petrovci' },
        { value: 'Grad', name: 'Grad' },
        { value: 'Grosuplje', name: 'Grosuplje' },
        { value: 'Hajdina', name: 'Hajdina' },
        { value: 'Hoce-Slivnica', name: 'Hoce-Slivnica' },
        { value: 'Hodos-Hodos', name: 'Hodos-Hodos' },
        { value: 'Horjul', name: 'Horjul' },
        { value: 'Hrastnik', name: 'Hrastnik' },
        { value: 'Hrpelje-Kozina', name: 'Hrpelje-Kozina' },
        { value: 'Idrija', name: 'Idrija' },
        { value: 'Ig', name: 'Ig' },
        { value: 'Ilirska Bistrica', name: 'Ilirska Bistrica' },
        { value: 'Ivancna Gorica', name: 'Ivancna Gorica' },
        { value: 'Izola-Isola', name: 'Izola-Isola' },
        { value: 'Jesenice', name: 'Jesenice' },
        { value: 'Jezersko', name: 'Jezersko' },
        { value: 'Jursinci', name: 'Jursinci' },
        { value: 'Kamnik', name: 'Kamnik' },
        { value: 'Kanal', name: 'Kanal' },
        { value: 'Kidricevo', name: 'Kidricevo' },
        { value: 'Kobarid', name: 'Kobarid' },
        { value: 'Kobilje', name: 'Kobilje' },
        { value: 'Kocevje', name: 'Kocevje' },
        { value: 'Komen', name: 'Komen' },
        { value: 'Komenda', name: 'Komenda' },
        { value: 'Koper-Capodistria', name: 'Koper-Capodistria' },
        { value: 'Kostel', name: 'Kostel' },
        { value: 'Kozje', name: 'Kozje' },
        { value: 'Kranj', name: 'Kranj' },
        { value: 'Kranjska Gora', name: 'Kranjska Gora' },
        { value: 'Krizevci', name: 'Krizevci' },
        { value: 'Krsko', name: 'Krsko' },
        { value: 'Kungota', name: 'Kungota' },
        { value: 'Kuzma', name: 'Kuzma' },
        { value: 'Lasko', name: 'Lasko' },
        { value: 'Lenart', name: 'Lenart' },
        { value: 'Lendava-Lendva', name: 'Lendava-Lendva' },
        { value: 'Litija', name: 'Litija' },
        { value: 'Ljubljana', name: 'Ljubljana' },
        { value: 'Ljubno', name: 'Ljubno' },
        { value: 'Ljutomer', name: 'Ljutomer' },
        { value: 'Logatec', name: 'Logatec' },
        { value: 'Loska Dolina', name: 'Loska Dolina' },
        { value: 'Loski Potok', name: 'Loski Potok' },
        { value: 'Lovrenc na Pohorju', name: 'Lovrenc na Pohorju' },
        { value: 'Luce', name: 'Luce' },
        { value: 'Lukovica', name: 'Lukovica' },
        { value: 'Majsperk', name: 'Majsperk' },
        { value: 'Maribor', name: 'Maribor' },
        { value: 'Markovci', name: 'Markovci' },
        { value: 'Medvode', name: 'Medvode' },
        { value: 'Menges', name: 'Menges' },
        { value: 'Metlika', name: 'Metlika' },
        { value: 'Mezica', name: 'Mezica' },
        { value: 'Miklavz na Dravskem Polju', name: 'Miklavz na Dravskem Polju' },
        { value: 'Miren-Kostanjevica', name: 'Miren-Kostanjevica' },
        { value: 'Mirna Pec', name: 'Mirna Pec' },
        { value: 'Mislinja', name: 'Mislinja' },
        { value: 'Moravce', name: 'Moravce' },
        { value: 'Moravske Toplice', name: 'Moravske Toplice' },
        { value: 'Mozirje', name: 'Mozirje' },
        { value: 'Murska Sobota', name: 'Murska Sobota' },
        { value: 'Muta', name: 'Muta' },
        { value: 'Naklo', name: 'Naklo' },
        { value: 'Nazarje', name: 'Nazarje' },
        { value: 'Nova Gorica', name: 'Nova Gorica' },
        { value: 'Novo Mesto', name: 'Novo Mesto' },
        { value: 'Odranci', name: 'Odranci' },
        { value: 'Oplotnica', name: 'Oplotnica' },
        { value: 'Ormoz', name: 'Ormoz' },
        { value: 'Osilnica', name: 'Osilnica' },
        { value: 'Pesnica', name: 'Pesnica' },
        { value: 'Piran-Pirano', name: 'Piran-Pirano' },
        { value: 'Pivka', name: 'Pivka' },
        { value: 'Podcetrtek', name: 'Podcetrtek' },
        { value: 'Podlehnik', name: 'Podlehnik' },
        { value: 'Podvelka', name: 'Podvelka' },
        { value: 'Polzela', name: 'Polzela' },
        { value: 'Postojna', name: 'Postojna' },
        { value: 'Prebold', name: 'Prebold' },
        { value: 'Preddvor', name: 'Preddvor' },
        { value: 'Prevalje', name: 'Prevalje' },
        { value: 'Ptuj', name: 'Ptuj' },
        { value: 'Puconci', name: 'Puconci' },
        { value: 'Race-Fram', name: 'Race-Fram' },
        { value: 'Radece', name: 'Radece' },
        { value: 'Radenci', name: 'Radenci' },
        { value: 'Radlje ob Dravi', name: 'Radlje ob Dravi' },
        { value: 'Radovljica', name: 'Radovljica' },
        { value: 'Ravne na Koroskem', name: 'Ravne na Koroskem' },
        { value: 'Razkrizje', name: 'Razkrizje' },
        { value: 'Ribnica', name: 'Ribnica' },
        { value: 'Ribnica na Pohorju', name: 'Ribnica na Pohorju' },
        { value: 'Rogasovci', name: 'Rogasovci' },
        { value: 'Rogaska Slatina', name: 'Rogaska Slatina' },
        { value: 'Rogatec', name: 'Rogatec' },
        { value: 'Ruse', name: 'Ruse' },
        { value: 'Salovci', name: 'Salovci' },
        { value: 'Selnica ob Dravi', name: 'Selnica ob Dravi' },
        { value: 'Semic', name: 'Semic' },
        { value: 'Sempeter-Vrtojba', name: 'Sempeter-Vrtojba' },
        { value: 'Sencur', name: 'Sencur' },
        { value: 'Sentilj', name: 'Sentilj' },
        { value: 'Sentjernej', name: 'Sentjernej' },
        { value: 'Sentjur pri Celju', name: 'Sentjur pri Celju' },
        { value: 'Sevnica', name: 'Sevnica' },
        { value: 'Sezana', name: 'Sezana' },
        { value: 'Skocjan', name: 'Skocjan' },
        { value: 'Skofja Loka', name: 'Skofja Loka' },
        { value: 'Skofljica', name: 'Skofljica' },
        { value: 'Slovenj Gradec', name: 'Slovenj Gradec' },
        { value: 'Slovenska Bistrica', name: 'Slovenska Bistrica' },
        { value: 'Slovenske Konjice', name: 'Slovenske Konjice' },
        { value: 'Smarje pri Jelsah', name: 'Smarje pri Jelsah' },
        { value: 'Smartno ob Paki', name: 'Smartno ob Paki' },
        { value: 'Smartno pri Litiji', name: 'Smartno pri Litiji' },
        { value: 'Sodrazica', name: 'Sodrazica' },
        { value: 'Solcava', name: 'Solcava' },
        { value: 'Sostanj', name: 'Sostanj' },
        { value: 'Starse', name: 'Starse' },
        { value: 'Store', name: 'Store' },
        { value: 'Sveta Ana', name: 'Sveta Ana' },
        { value: 'Sveti Andraz v Slovenskih Goricah', name: 'Sveti Andraz v Slovenskih Goricah' },
        { value: 'Sveti Jurij', name: 'Sveti Jurij' },
        { value: 'Tabor', name: 'Tabor' },
        { value: 'Tisina', name: 'Tisina' },
        { value: 'Tolmin', name: 'Tolmin' },
        { value: 'Trbovlje', name: 'Trbovlje' },
        { value: 'Trebnje', name: 'Trebnje' },
        { value: 'Trnovska Vas', name: 'Trnovska Vas' },
        { value: 'Trzic', name: 'Trzic' },
        { value: 'Trzin', name: 'Trzin' },
        { value: 'Turnisce', name: 'Turnisce' },
        { value: 'Velenje', name: 'Velenje' },
        { value: 'Velika Polana', name: 'Velika Polana' },
        { value: 'Velike Lasce', name: 'Velike Lasce' },
        { value: 'Verzej', name: 'Verzej' },
        { value: 'Videm', name: 'Videm' },
        { value: 'Vipava', name: 'Vipava' },
        { value: 'Vitanje', name: 'Vitanje' },
        { value: 'Vodice', name: 'Vodice' },
        { value: 'Vojnik', name: 'Vojnik' },
        { value: 'Vransko', name: 'Vransko' },
        { value: 'Vrhnika', name: 'Vrhnika' },
        { value: 'Vuzenica', name: 'Vuzenica' },
        { value: 'Zagorje ob Savi', name: 'Zagorje ob Savi' },
        { value: 'Zalec', name: 'Zalec' },
        { value: 'Zavrc', name: 'Zavrc' },
        { value: 'Zelezniki', name: 'Zelezniki' },
        { value: 'Zetale', name: 'Zetale' },
        { value: 'Ziri', name: 'Ziri' },
        { value: 'Zirovnica', name: 'Zirovnica' },
        { value: 'Zuzemberk', name: 'Zuzemberk' },
        { value: 'Zrece', name: 'Zrece' },
    ],
    SB: [
        { value: 'Central', name: 'Central' },
        { value: 'Choiseul', name: 'Choiseul' },
        { value: 'Guadalcanal', name: 'Guadalcanal' },
        { value: 'Honiara', name: 'Honiara' },
        { value: 'Isabel', name: 'Isabel' },
        { value: 'Makira', name: 'Makira' },
        { value: 'Malaita', name: 'Malaita' },
        { value: 'Rennell and Bellona', name: 'Rennell and Bellona' },
        { value: 'Temotu', name: 'Temotu' },
        { value: 'Western', name: 'Western' },
    ],
    ZA: [
        { value: 'Eastern Cape', name: 'Eastern Cape' },
        { value: 'Free State', name: 'Free State' },
        { value: 'Gauteng', name: 'Gauteng' },
        { value: 'KwaZulu-Natal', name: 'KwaZulu-Natal' },
        { value: 'Limpopo', name: 'Limpopo' },
        { value: 'Mpumalanga', name: 'Mpumalanga' },
        { value: 'North-West', name: 'North-West' },
        { value: 'Northern Cape', name: 'Northern Cape' },
        { value: 'Western Cape', name: 'Western Cape' },
    ],
    ES: [
        { value: 'Andalucia', name: 'Andalucia' },
        { value: 'Aragon', name: 'Aragon' },
        { value: 'Asturias', name: 'Asturias' },
        { value: 'Baleares', name: 'Baleares' },
        { value: 'Ceuta', name: 'Ceuta' },
        { value: 'Canarias', name: 'Canarias' },
        { value: 'Cantabria', name: 'Cantabria' },
        { value: 'Castilla-La Mancha', name: 'Castilla-La Mancha' },
        { value: 'Castilla y Leon', name: 'Castilla y Leon' },
        { value: 'Cataluna', name: 'Cataluna' },
        { value: 'Comunidad Valenciana', name: 'Comunidad Valenciana' },
        { value: 'Extremadura', name: 'Extremadura' },
        { value: 'Galicia', name: 'Galicia' },
        { value: 'La Rioja', name: 'La Rioja' },
        { value: 'Madrid', name: 'Madrid' },
        { value: 'Melilla', name: 'Melilla' },
        { value: 'Murcia', name: 'Murcia' },
        { value: 'Navarra', name: 'Navarra' },
        { value: 'Pais Vasco', name: 'Pais Vasco' },
    ],
    LK: [
        { value: 'Central', name: 'Central' },
        { value: 'North Central', name: 'North Central' },
        { value: 'North Eastern', name: 'North Eastern' },
        { value: 'North Western', name: 'North Western' },
        { value: 'Sabaragamuwa', name: 'Sabaragamuwa' },
        { value: 'Southern', name: 'Southern' },
        { value: 'Uva', name: 'Uva' },
        { value: 'Western', name: 'Western' },
    ],
    SR: [
        { value: 'Brokopondo', name: 'Brokopondo' },
        { value: 'Commewijne', name: 'Commewijne' },
        { value: 'Coronie', name: 'Coronie' },
        { value: 'Marowijne', name: 'Marowijne' },
        { value: 'Nickerie', name: 'Nickerie' },
        { value: 'Para', name: 'Para' },
        { value: 'Paramaribo', name: 'Paramaribo' },
        { value: 'Saramacca', name: 'Saramacca' },
        { value: 'Sipaliwini', name: 'Sipaliwini' },
        { value: 'Wanica', name: 'Wanica' },
    ],
    SE: [
        { value: 'Blekinge', name: 'Blekinge' },
        { value: 'Dalarnas', name: 'Dalarnas' },
        { value: 'Gavleborgs', name: 'Gavleborgs' },
        { value: 'Gotlands', name: 'Gotlands' },
        { value: 'Hallands', name: 'Hallands' },
        { value: 'Jamtlands', name: 'Jamtlands' },
        { value: 'Jonkopings', name: 'Jonkopings' },
        { value: 'Kalmar', name: 'Kalmar' },
        { value: 'Kronobergs', name: 'Kronobergs' },
        { value: 'Norrbottens', name: 'Norrbottens' },
        { value: 'Orebro', name: 'Orebro' },
        { value: 'Ostergotlands', name: 'Ostergotlands' },
        { value: 'Skane', name: 'Skane' },
        { value: 'Sodermanlands', name: 'Sodermanlands' },
        { value: 'Stockholms', name: 'Stockholms' },
        { value: 'Uppsala', name: 'Uppsala' },
        { value: 'Varmlands', name: 'Varmlands' },
        { value: 'Vasterbottens', name: 'Vasterbottens' },
        { value: 'Vasternorrlands', name: 'Vasternorrlands' },
        { value: 'Vastmanlands', name: 'Vastmanlands' },
        { value: 'Vastra Gotalands', name: 'Vastra Gotalands' },
    ],
    CH: [
        { value: 'Aargau', name: 'Aargau' },
        { value: 'Appenzell Ausser-Rhoden', name: 'Appenzell Ausser-Rhoden' },
        { value: 'Appenzell Inner-Rhoden', name: 'Appenzell Inner-Rhoden' },
        { value: 'Basel-Landschaft', name: 'Basel-Landschaft' },
        { value: 'Basel-Stadt', name: 'Basel-Stadt' },
        { value: 'Bern', name: 'Bern' },
        { value: 'Fribourg', name: 'Fribourg' },
        { value: 'Geneve', name: 'Geneve' },
        { value: 'Glarus', name: 'Glarus' },
        { value: 'Graubunden', name: 'Graubunden' },
        { value: 'Jura', name: 'Jura' },
        { value: 'Luzern', name: 'Luzern' },
        { value: 'Neuchatel', name: 'Neuchatel' },
        { value: 'Nidwalden', name: 'Nidwalden' },
        { value: 'Obwalden', name: 'Obwalden' },
        { value: 'Sankt Gallen', name: 'Sankt Gallen' },
        { value: 'Schaffhausen', name: 'Schaffhausen' },
        { value: 'Schwyz', name: 'Schwyz' },
        { value: 'Solothurn', name: 'Solothurn' },
        { value: 'Thurgau', name: 'Thurgau' },
        { value: 'Ticino', name: 'Ticino' },
        { value: 'Uri', name: 'Uri' },
        { value: 'Valais', name: 'Valais' },
        { value: 'Vaud', name: 'Vaud' },
        { value: 'Zug', name: 'Zug' },
        { value: 'Zurich', name: 'Zurich' },
    ],
    TW: [
        { value: 'Chang-hua', name: 'Chang-hua' },
        { value: 'Chia-i', name: 'Chia-i' },
        { value: 'Hsin-chu', name: 'Hsin-chu' },
        { value: 'Hua-lien', name: 'Hua-lien' },
        { value: 'I-lan', name: 'I-lan' },
        { value: 'Kao-hsiung', name: 'Kao-hsiung' },
        { value: 'Kin-men', name: 'Kin-men' },
        { value: 'Lien-chiang', name: 'Lien-chiang' },
        { value: 'Miao-li', name: 'Miao-li' },
        { value: "Nan-t'ou", name: "Nan-t'ou" },
        { value: "P'eng-hu", name: "P'eng-hu" },
        { value: "P'ing-tung", name: "P'ing-tung" },
        { value: "T'ai-chung", name: "T'ai-chung" },
        { value: "T'ai-nan", name: "T'ai-nan" },
        { value: "T'ai-pei", name: "T'ai-pei" },
        { value: "T'ai-tung", name: "T'ai-tung" },
        { value: "T'ao-yuan", name: "T'ao-yuan" },
        { value: 'Yun-lin', name: 'Yun-lin' },
        { value: 'Chia-i', name: 'Chia-i' },
        { value: 'Chi-lung', name: 'Chi-lung' },
        { value: 'Hsin-chu', name: 'Hsin-chu' },
        { value: "T'ai-chung", name: "T'ai-chung" },
        { value: "T'ai-nan", name: "T'ai-nan" },
        { value: 'Kao-hsiung city', name: 'Kao-hsiung city' },
        { value: "T'ai-pei city", name: "T'ai-pei city" },
    ],
    TZ: [
        { value: 'Arusha', name: 'Arusha' },
        { value: 'Dar es Salaam', name: 'Dar es Salaam' },
        { value: 'Dodoma', name: 'Dodoma' },
        { value: 'Iringa', name: 'Iringa' },
        { value: 'Kagera', name: 'Kagera' },
        { value: 'Kigoma', name: 'Kigoma' },
        { value: 'Kilimanjaro', name: 'Kilimanjaro' },
        { value: 'Lindi', name: 'Lindi' },
        { value: 'Manyara', name: 'Manyara' },
        { value: 'Mara', name: 'Mara' },
        { value: 'Mbeya', name: 'Mbeya' },
        { value: 'Morogoro', name: 'Morogoro' },
        { value: 'Mtwara', name: 'Mtwara' },
        { value: 'Mwanza', name: 'Mwanza' },
        { value: 'Pemba North', name: 'Pemba North' },
        { value: 'Pemba South', name: 'Pemba South' },
        { value: 'Pwani', name: 'Pwani' },
        { value: 'Rukwa', name: 'Rukwa' },
        { value: 'Ruvuma', name: 'Ruvuma' },
        { value: 'Shinyanga', name: 'Shinyanga' },
        { value: 'Singida', name: 'Singida' },
        { value: 'Tabora', name: 'Tabora' },
        { value: 'Tanga', name: 'Tanga' },
        { value: 'Zanzibar Central/South', name: 'Zanzibar Central/South' },
        { value: 'Zanzibar North', name: 'Zanzibar North' },
        { value: 'Zanzibar Urban/West', name: 'Zanzibar Urban/West' },
    ],
    TH: [
        { value: 'Amnat Charoen', name: 'Amnat Charoen' },
        { value: 'Ang Thong', name: 'Ang Thong' },
        { value: 'Buriram', name: 'Buriram' },
        { value: 'Chachoengsao', name: 'Chachoengsao' },
        { value: 'Chai Nat', name: 'Chai Nat' },
        { value: 'Chaiyaphum', name: 'Chaiyaphum' },
        { value: 'Chanthaburi', name: 'Chanthaburi' },
        { value: 'Chiang Mai', name: 'Chiang Mai' },
        { value: 'Chiang Rai', name: 'Chiang Rai' },
        { value: 'Chon Buri', name: 'Chon Buri' },
        { value: 'Chumphon', name: 'Chumphon' },
        { value: 'Kalasin', name: 'Kalasin' },
        { value: 'Kamphaeng Phet', name: 'Kamphaeng Phet' },
        { value: 'Kanchanaburi', name: 'Kanchanaburi' },
        { value: 'Khon Kaen', name: 'Khon Kaen' },
        { value: 'Krabi', name: 'Krabi' },
        { value: 'Krung Thep Mahanakhon', name: 'Krung Thep Mahanakhon' },
        { value: 'Lampang', name: 'Lampang' },
        { value: 'Lamphun', name: 'Lamphun' },
        { value: 'Loei', name: 'Loei' },
        { value: 'Lop Buri', name: 'Lop Buri' },
        { value: 'Mae Hong Son', name: 'Mae Hong Son' },
        { value: 'Maha Sarakham', name: 'Maha Sarakham' },
        { value: 'Mukdahan', name: 'Mukdahan' },
        { value: 'Nakhon Nayok', name: 'Nakhon Nayok' },
        { value: 'Nakhon Pathom', name: 'Nakhon Pathom' },
        { value: 'Nakhon Phanom', name: 'Nakhon Phanom' },
        { value: 'Nakhon Ratchasima', name: 'Nakhon Ratchasima' },
        { value: 'Nakhon Sawan', name: 'Nakhon Sawan' },
        { value: 'Nakhon Si Thammarat', name: 'Nakhon Si Thammarat' },
        { value: 'Nan', name: 'Nan' },
        { value: 'Narathiwat', name: 'Narathiwat' },
        { value: 'Nong Bua Lamphu', name: 'Nong Bua Lamphu' },
        { value: 'Nong Khai', name: 'Nong Khai' },
        { value: 'Nonthaburi', name: 'Nonthaburi' },
        { value: 'Pathum Thani', name: 'Pathum Thani' },
        { value: 'Pattani', name: 'Pattani' },
        { value: 'Phangnga', name: 'Phangnga' },
        { value: 'Phatthalung', name: 'Phatthalung' },
        { value: 'Phayao', name: 'Phayao' },
        { value: 'Phetchabun', name: 'Phetchabun' },
        { value: 'Phetchaburi', name: 'Phetchaburi' },
        { value: 'Phichit', name: 'Phichit' },
        { value: 'Phitsanulok', name: 'Phitsanulok' },
        { value: 'Phra Nakhon Si Ayutthaya', name: 'Phra Nakhon Si Ayutthaya' },
        { value: 'Phrae', name: 'Phrae' },
        { value: 'Phuket', name: 'Phuket' },
        { value: 'Prachin Buri', name: 'Prachin Buri' },
        { value: 'Prachuap Khiri Khan', name: 'Prachuap Khiri Khan' },
        { value: 'Ranong', name: 'Ranong' },
        { value: 'Ratchaburi', name: 'Ratchaburi' },
        { value: 'Rayong', name: 'Rayong' },
        { value: 'Roi Et', name: 'Roi Et' },
        { value: 'Sa Kaeo', name: 'Sa Kaeo' },
        { value: 'Sakon Nakhon', name: 'Sakon Nakhon' },
        { value: 'Samut Prakan', name: 'Samut Prakan' },
        { value: 'Samut Sakhon', name: 'Samut Sakhon' },
        { value: 'Samut Songkhram', name: 'Samut Songkhram' },
        { value: 'Sara Buri', name: 'Sara Buri' },
        { value: 'Satun', name: 'Satun' },
        { value: 'Sing Buri', name: 'Sing Buri' },
        { value: 'Sisaket', name: 'Sisaket' },
        { value: 'Songkhla', name: 'Songkhla' },
        { value: 'Sukhothai', name: 'Sukhothai' },
        { value: 'Suphan Buri', name: 'Suphan Buri' },
        { value: 'Surat Thani', name: 'Surat Thani' },
        { value: 'Surin', name: 'Surin' },
        { value: 'Tak', name: 'Tak' },
        { value: 'Trang', name: 'Trang' },
        { value: 'Trat', name: 'Trat' },
        { value: 'Ubon Ratchathani', name: 'Ubon Ratchathani' },
        { value: 'Udon Thani', name: 'Udon Thani' },
        { value: 'Uthai Thani', name: 'Uthai Thani' },
        { value: 'Uttaradit', name: 'Uttaradit' },
        { value: 'Yala', name: 'Yala' },
        { value: 'Yasothon', name: 'Yasothon' },
    ],
    TG: [
        { value: 'Kara', name: 'Kara' },
        { value: 'Plateaux', name: 'Plateaux' },
        { value: 'Savanes', name: 'Savanes' },
        { value: 'Centrale', name: 'Centrale' },
        { value: 'Maritime', name: 'Maritime' },
    ],
    TT: [
        { value: 'Couva', name: 'Couva' },
        { value: 'Diego Martin', name: 'Diego Martin' },
        { value: 'Mayaro', name: 'Mayaro' },
        { value: 'Penal', name: 'Penal' },
        { value: 'Princes Town', name: 'Princes Town' },
        { value: 'Sangre Grande', name: 'Sangre Grande' },
        { value: 'San Juan', name: 'San Juan' },
        { value: 'Siparia', name: 'Siparia' },
        { value: 'Tunapuna', name: 'Tunapuna' },
        { value: 'Port-of-Spain', name: 'Port-of-Spain' },
        { value: 'San Fernando', name: 'San Fernando' },
        { value: 'Arima', name: 'Arima' },
        { value: 'Point Fortin', name: 'Point Fortin' },
        { value: 'Chaguanas', name: 'Chaguanas' },
        { value: 'Tobago', name: 'Tobago' },
    ],
    TN: [
        { value: 'Ariana (Aryanah)', name: 'Ariana (Aryanah)' },
        { value: 'Beja (Bajah)', name: 'Beja (Bajah)' },
        { value: "Ben Arous (Bin 'Arus)", name: "Ben Arous (Bin 'Arus)" },
        { value: 'Bizerte (Banzart)', name: 'Bizerte (Banzart)' },
        { value: 'Gabes (Qabis)', name: 'Gabes (Qabis)' },
        { value: 'Gafsa (Qafsah)', name: 'Gafsa (Qafsah)' },
        { value: 'Jendouba (Jundubah)', name: 'Jendouba (Jundubah)' },
        { value: 'Kairouan (Al Qayrawan)', name: 'Kairouan (Al Qayrawan)' },
        { value: 'Kasserine (Al Qasrayn)', name: 'Kasserine (Al Qasrayn)' },
        { value: 'Kebili (Qibili)', name: 'Kebili (Qibili)' },
        { value: 'Kef (Al Kaf)', name: 'Kef (Al Kaf)' },
        { value: 'Mahdia (Al Mahdiyah)', name: 'Mahdia (Al Mahdiyah)' },
        { value: 'Manouba (Manubah)', name: 'Manouba (Manubah)' },
        { value: 'Medenine (Madanin)', name: 'Medenine (Madanin)' },
        { value: 'Monastir (Al Munastir)', name: 'Monastir (Al Munastir)' },
        { value: 'Nabeul (Nabul)', name: 'Nabeul (Nabul)' },
        { value: 'Sfax (Safaqis)', name: 'Sfax (Safaqis)' },
        { value: 'Sidi Bou Zid (Sidi Bu Zayd)', name: 'Sidi Bou Zid (Sidi Bu Zayd)' },
        { value: 'Siliana (Silyanah)', name: 'Siliana (Silyanah)' },
        { value: 'Sousse (Susah)', name: 'Sousse (Susah)' },
        { value: 'Tataouine (Tatawin)', name: 'Tataouine (Tatawin)' },
        { value: 'Tozeur (Tawzar)', name: 'Tozeur (Tawzar)' },
        { value: 'Tunis', name: 'Tunis' },
        { value: 'Zaghouan (Zaghwan)', name: 'Zaghouan (Zaghwan)' },
    ],
    TR: [
        { value: 'Adana', name: 'Adana' },
        { value: 'Adiyaman', name: 'Adiyaman' },
        { value: 'Afyonkarahisar', name: 'Afyonkarahisar' },
        { value: 'Agri', name: 'Agri' },
        { value: 'Aksaray', name: 'Aksaray' },
        { value: 'Amasya', name: 'Amasya' },
        { value: 'Ankara', name: 'Ankara' },
        { value: 'Antalya', name: 'Antalya' },
        { value: 'Ardahan', name: 'Ardahan' },
        { value: 'Artvin', name: 'Artvin' },
        { value: 'Aydin', name: 'Aydin' },
        { value: 'Balikesir', name: 'Balikesir' },
        { value: 'Bartin', name: 'Bartin' },
        { value: 'Batman', name: 'Batman' },
        { value: 'Bayburt', name: 'Bayburt' },
        { value: 'Bilecik', name: 'Bilecik' },
        { value: 'Bingol', name: 'Bingol' },
        { value: 'Bitlis', name: 'Bitlis' },
        { value: 'Bolu', name: 'Bolu' },
        { value: 'Burdur', name: 'Burdur' },
        { value: 'Bursa', name: 'Bursa' },
        { value: 'Canakkale', name: 'Canakkale' },
        { value: 'Cankiri', name: 'Cankiri' },
        { value: 'Corum', name: 'Corum' },
        { value: 'Denizli', name: 'Denizli' },
        { value: 'Diyarbakir', name: 'Diyarbakir' },
        { value: 'Duzce', name: 'Duzce' },
        { value: 'Edirne', name: 'Edirne' },
        { value: 'Elazig', name: 'Elazig' },
        { value: 'Erzincan', name: 'Erzincan' },
        { value: 'Erzurum', name: 'Erzurum' },
        { value: 'Eskisehir', name: 'Eskisehir' },
        { value: 'Gaziantep', name: 'Gaziantep' },
        { value: 'Giresun', name: 'Giresun' },
        { value: 'Gumushane', name: 'Gumushane' },
        { value: 'Hakkari', name: 'Hakkari' },
        { value: 'Hatay', name: 'Hatay' },
        { value: 'Igdir', name: 'Igdir' },
        { value: 'Isparta', name: 'Isparta' },
        { value: 'Istanbul', name: 'Istanbul' },
        { value: 'Izmir', name: 'Izmir' },
        { value: 'Kahramanmaras', name: 'Kahramanmaras' },
        { value: 'Karabuk', name: 'Karabuk' },
        { value: 'Karaman', name: 'Karaman' },
        { value: 'Kars', name: 'Kars' },
        { value: 'Kastamonu', name: 'Kastamonu' },
        { value: 'Kayseri', name: 'Kayseri' },
        { value: 'Kilis', name: 'Kilis' },
        { value: 'Kirikkale', name: 'Kirikkale' },
        { value: 'Kirklareli', name: 'Kirklareli' },
        { value: 'Kirsehir', name: 'Kirsehir' },
        { value: 'Kocaeli', name: 'Kocaeli' },
        { value: 'Konya', name: 'Konya' },
        { value: 'Kutahya', name: 'Kutahya' },
        { value: 'Malatya', name: 'Malatya' },
        { value: 'Manisa', name: 'Manisa' },
        { value: 'Mardin', name: 'Mardin' },
        { value: 'Mersin', name: 'Mersin' },
        { value: 'Mugla', name: 'Mugla' },
        { value: 'Mus', name: 'Mus' },
        { value: 'Nevsehir', name: 'Nevsehir' },
        { value: 'Nigde', name: 'Nigde' },
        { value: 'Ordu', name: 'Ordu' },
        { value: 'Osmaniye', name: 'Osmaniye' },
        { value: 'Rize', name: 'Rize' },
        { value: 'Sakarya', name: 'Sakarya' },
        { value: 'Samsun', name: 'Samsun' },
        { value: 'Sanliurfa', name: 'Sanliurfa' },
        { value: 'Siirt', name: 'Siirt' },
        { value: 'Sinop', name: 'Sinop' },
        { value: 'Sirnak', name: 'Sirnak' },
        { value: 'Sivas', name: 'Sivas' },
        { value: 'Tekirdag', name: 'Tekirdag' },
        { value: 'Tokat', name: 'Tokat' },
        { value: 'Trabzon', name: 'Trabzon' },
        { value: 'Tunceli', name: 'Tunceli' },
        { value: 'Usak', name: 'Usak' },
        { value: 'Van', name: 'Van' },
        { value: 'Yalova', name: 'Yalova' },
        { value: 'Yozgat', name: 'Yozgat' },
        { value: 'Zonguldak', name: 'Zonguldak' },
    ],
    TM: [
        { value: 'Ahal Welayaty (Ashgabat)', name: 'Ahal Welayaty (Ashgabat)' },
        { value: 'Balkan Welayaty (Balkanabat)', name: 'Balkan Welayaty (Balkanabat)' },
        { value: 'Dashoguz Welayaty', name: 'Dashoguz Welayaty' },
        { value: 'Lebap Welayaty (Turkmenabat)', name: 'Lebap Welayaty (Turkmenabat)' },
        { value: 'Mary Welayaty', name: 'Mary Welayaty' },
    ],
    UG: [
        { value: 'Adjumani', name: 'Adjumani' },
        { value: 'Apac', name: 'Apac' },
        { value: 'Arua', name: 'Arua' },
        { value: 'Bugiri', name: 'Bugiri' },
        { value: 'Bundibugyo', name: 'Bundibugyo' },
        { value: 'Bushenyi', name: 'Bushenyi' },
        { value: 'Busia', name: 'Busia' },
        { value: 'Gulu', name: 'Gulu' },
        { value: 'Hoima', name: 'Hoima' },
        { value: 'Iganga', name: 'Iganga' },
        { value: 'Jinja', name: 'Jinja' },
        { value: 'Kabale', name: 'Kabale' },
        { value: 'Kabarole', name: 'Kabarole' },
        { value: 'Kaberamaido', name: 'Kaberamaido' },
        { value: 'Kalangala', name: 'Kalangala' },
        { value: 'Kampala', name: 'Kampala' },
        { value: 'Kamuli', name: 'Kamuli' },
        { value: 'Kamwenge', name: 'Kamwenge' },
        { value: 'Kanungu', name: 'Kanungu' },
        { value: 'Kapchorwa', name: 'Kapchorwa' },
        { value: 'Kasese', name: 'Kasese' },
        { value: 'Katakwi', name: 'Katakwi' },
        { value: 'Kayunga', name: 'Kayunga' },
        { value: 'Kibale', name: 'Kibale' },
        { value: 'Kiboga', name: 'Kiboga' },
        { value: 'Kisoro', name: 'Kisoro' },
        { value: 'Kitgum', name: 'Kitgum' },
        { value: 'Kotido', name: 'Kotido' },
        { value: 'Kumi', name: 'Kumi' },
        { value: 'Kyenjojo', name: 'Kyenjojo' },
        { value: 'Lira', name: 'Lira' },
        { value: 'Luwero', name: 'Luwero' },
        { value: 'Masaka', name: 'Masaka' },
        { value: 'Masindi', name: 'Masindi' },
        { value: 'Mayuge', name: 'Mayuge' },
        { value: 'Mbale', name: 'Mbale' },
        { value: 'Mbarara', name: 'Mbarara' },
        { value: 'Moroto', name: 'Moroto' },
        { value: 'Moyo', name: 'Moyo' },
        { value: 'Mpigi', name: 'Mpigi' },
        { value: 'Mubende', name: 'Mubende' },
        { value: 'Mukono', name: 'Mukono' },
        { value: 'Nakapiripirit', name: 'Nakapiripirit' },
        { value: 'Nakasongola', name: 'Nakasongola' },
        { value: 'Nebbi', name: 'Nebbi' },
        { value: 'Ntungamo', name: 'Ntungamo' },
        { value: 'Pader', name: 'Pader' },
        { value: 'Pallisa', name: 'Pallisa' },
        { value: 'Rakai', name: 'Rakai' },
        { value: 'Rukungiri', name: 'Rukungiri' },
        { value: 'Sembabule', name: 'Sembabule' },
        { value: 'Sironko', name: 'Sironko' },
        { value: 'Soroti', name: 'Soroti' },
        { value: 'Tororo', name: 'Tororo' },
        { value: 'Wakiso', name: 'Wakiso' },
        { value: 'Yumbe', name: 'Yumbe' },
    ],
    UA: [
        { value: 'Cherkasy', name: 'Cherkasy' },
        { value: 'Chernihiv', name: 'Chernihiv' },
        { value: 'Chernivtsi', name: 'Chernivtsi' },
        { value: 'Crimea', name: 'Crimea' },
        { value: "Dnipropetrovs'k", name: "Dnipropetrovs'k" },
        { value: "Donets'k", name: "Donets'k" },
        { value: "Ivano-Frankivs'k", name: "Ivano-Frankivs'k" },
        { value: 'Kharkiv', name: 'Kharkiv' },
        { value: 'Kherson', name: 'Kherson' },
        { value: "Khmel'nyts'kyy", name: "Khmel'nyts'kyy" },
        { value: 'Kirovohrad', name: 'Kirovohrad' },
        { value: 'Kiev', name: 'Kiev' },
        { value: 'Kyyiv', name: 'Kyyiv' },
        { value: "Luhans'k", name: "Luhans'k" },
        { value: "L'viv", name: "L'viv" },
        { value: 'Mykolayiv', name: 'Mykolayiv' },
        { value: 'Odesa', name: 'Odesa' },
        { value: 'Poltava', name: 'Poltava' },
        { value: 'Rivne', name: 'Rivne' },
        { value: "Sevastopol'", name: "Sevastopol'" },
        { value: 'Sumy', name: 'Sumy' },
        { value: "Ternopil'", name: "Ternopil'" },
        { value: 'Vinnytsya', name: 'Vinnytsya' },
        { value: "Volyn'", name: "Volyn'" },
        { value: 'Zakarpattya', name: 'Zakarpattya' },
        { value: 'Zaporizhzhya', name: 'Zaporizhzhya' },
        { value: 'Zhytomyr', name: 'Zhytomyr' },
    ],
    AE: [
        { value: 'Abu Dhabi', name: 'Abu Dhabi' },
        { value: "'Ajman", name: "'Ajman" },
        { value: 'Al Fujayrah', name: 'Al Fujayrah' },
        { value: 'Sharjah', name: 'Sharjah' },
        { value: 'Dubai', name: 'Dubai' },
        { value: "Ra's al Khaymah", name: "Ra's al Khaymah" },
        { value: 'Umm al Qaywayn', name: 'Umm al Qaywayn' },
    ],
    UY: [
        { value: 'Artigas', name: 'Artigas' },
        { value: 'Canelones', name: 'Canelones' },
        { value: 'Cerro Largo', name: 'Cerro Largo' },
        { value: 'Colonia', name: 'Colonia' },
        { value: 'Durazno', name: 'Durazno' },
        { value: 'Flores', name: 'Flores' },
        { value: 'Florida', name: 'Florida' },
        { value: 'Lavalleja', name: 'Lavalleja' },
        { value: 'Maldonado', name: 'Maldonado' },
        { value: 'Montevideo', name: 'Montevideo' },
        { value: 'Paysandu', name: 'Paysandu' },
        { value: 'Rio Negro', name: 'Rio Negro' },
        { value: 'Rivera', name: 'Rivera' },
        { value: 'Rocha', name: 'Rocha' },
        { value: 'Salto', name: 'Salto' },
        { value: 'San Jose', name: 'San Jose' },
        { value: 'Soriano', name: 'Soriano' },
        { value: 'Tacuarembo', name: 'Tacuarembo' },
        { value: 'Treinta y Tres', name: 'Treinta y Tres' },
    ],
    UZ: [
        { value: 'Andijon Viloyati', name: 'Andijon Viloyati' },
        { value: 'Buxoro Viloyati', name: 'Buxoro Viloyati' },
        { value: "Farg'ona Viloyati", name: "Farg'ona Viloyati" },
        { value: 'Jizzax Viloyati', name: 'Jizzax Viloyati' },
        { value: 'Namangan Viloyati', name: 'Namangan Viloyati' },
        { value: 'Navoiy Viloyati', name: 'Navoiy Viloyati' },
        { value: 'Qashqadaryo Viloyati', name: 'Qashqadaryo Viloyati' },
        { value: "Qaraqalpog'iston Respublikasi", name: "Qaraqalpog'iston Respublikasi" },
        { value: 'Samarqand Viloyati', name: 'Samarqand Viloyati' },
        { value: 'Sirdaryo Viloyati', name: 'Sirdaryo Viloyati' },
        { value: 'Surxondaryo Viloyati', name: 'Surxondaryo Viloyati' },
        { value: 'Toshkent Shahri', name: 'Toshkent Shahri' },
        { value: 'Toshkent Viloyati', name: 'Toshkent Viloyati' },
        { value: 'Xorazm Viloyati', name: 'Xorazm Viloyati' },
    ],
    VU: [
        { value: 'Malampa', name: 'Malampa' },
        { value: 'Penama', name: 'Penama' },
        { value: 'Sanma', name: 'Sanma' },
        { value: 'Shefa', name: 'Shefa' },
        { value: 'Tafea', name: 'Tafea' },
        { value: 'Torba', name: 'Torba' },
    ],
    VN: [
        { value: 'An Giang', name: 'An Giang' },
        { value: 'Bac Giang', name: 'Bac Giang' },
        { value: 'Bac Kan', name: 'Bac Kan' },
        { value: 'Bac Lieu', name: 'Bac Lieu' },
        { value: 'Bac Ninh', name: 'Bac Ninh' },
        { value: 'Ba Ria-Vung Tau', name: 'Ba Ria-Vung Tau' },
        { value: 'Ben Tre', name: 'Ben Tre' },
        { value: 'Binh Dinh', name: 'Binh Dinh' },
        { value: 'Binh Duong', name: 'Binh Duong' },
        { value: 'Binh Phuoc', name: 'Binh Phuoc' },
        { value: 'Binh Thuan', name: 'Binh Thuan' },
        { value: 'Ca Mau', name: 'Ca Mau' },
        { value: 'Cao Bang', name: 'Cao Bang' },
        { value: 'Dac Lak', name: 'Dac Lak' },
        { value: 'Dac Nong', name: 'Dac Nong' },
        { value: 'Dien Bien', name: 'Dien Bien' },
        { value: 'Dong Nai', name: 'Dong Nai' },
        { value: 'Dong Thap', name: 'Dong Thap' },
        { value: 'Gia Lai', name: 'Gia Lai' },
        { value: 'Ha Giang', name: 'Ha Giang' },
        { value: 'Hai Duong', name: 'Hai Duong' },
        { value: 'Ha Nam', name: 'Ha Nam' },
        { value: 'Ha Tay', name: 'Ha Tay' },
        { value: 'Ha Tinh', name: 'Ha Tinh' },
        { value: 'Hau Giang', name: 'Hau Giang' },
        { value: 'Hoa Binh', name: 'Hoa Binh' },
        { value: 'Hung Yen', name: 'Hung Yen' },
        { value: 'Khanh Hoa', name: 'Khanh Hoa' },
        { value: 'Kien Giang', name: 'Kien Giang' },
        { value: 'Kon Tum', name: 'Kon Tum' },
        { value: 'Lai Chau', name: 'Lai Chau' },
        { value: 'Lam Dong', name: 'Lam Dong' },
        { value: 'Lang Son', name: 'Lang Son' },
        { value: 'Lao Cai', name: 'Lao Cai' },
        { value: 'Long An', name: 'Long An' },
        { value: 'Nam Dinh', name: 'Nam Dinh' },
        { value: 'Nghe An', name: 'Nghe An' },
        { value: 'Ninh Binh', name: 'Ninh Binh' },
        { value: 'Ninh Thuan', name: 'Ninh Thuan' },
        { value: 'Phu Tho', name: 'Phu Tho' },
        { value: 'Phu Yen', name: 'Phu Yen' },
        { value: 'Quang Binh', name: 'Quang Binh' },
        { value: 'Quang Nam', name: 'Quang Nam' },
        { value: 'Quang Ngai', name: 'Quang Ngai' },
        { value: 'Quang Ninh', name: 'Quang Ninh' },
        { value: 'Quang Tri', name: 'Quang Tri' },
        { value: 'Soc Trang', name: 'Soc Trang' },
        { value: 'Son La', name: 'Son La' },
        { value: 'Tay Ninh', name: 'Tay Ninh' },
        { value: 'Thai Binh', name: 'Thai Binh' },
        { value: 'Thai Nguyen', name: 'Thai Nguyen' },
        { value: 'Thanh Hoa', name: 'Thanh Hoa' },
        { value: 'Thua Thien-Hue', name: 'Thua Thien-Hue' },
        { value: 'Tien Giang', name: 'Tien Giang' },
        { value: 'Tra Vinh', name: 'Tra Vinh' },
        { value: 'Tuyen Quang', name: 'Tuyen Quang' },
        { value: 'Vinh Long', name: 'Vinh Long' },
        { value: 'Vinh Phuc', name: 'Vinh Phuc' },
        { value: 'Yen Bai', name: 'Yen Bai' },
        { value: 'Can Tho', name: 'Can Tho' },
        { value: 'Da Nang', name: 'Da Nang' },
        { value: 'Hai Phong', name: 'Hai Phong' },
        { value: 'Hanoi', name: 'Hanoi' },
        { value: 'Ho Chi Minh', name: 'Ho Chi Minh' },
    ],
    ZM: [
        { value: 'Central', name: 'Central' },
        { value: 'Copperbelt', name: 'Copperbelt' },
        { value: 'Eastern', name: 'Eastern' },
        { value: 'Luapula', name: 'Luapula' },
        { value: 'Lusaka', name: 'Lusaka' },
        { value: 'Northern', name: 'Northern' },
        { value: 'North-Western', name: 'North-Western' },
        { value: 'Southern', name: 'Southern' },
        { value: 'Western', name: 'Western' },
    ],
    ZW: [
        { value: 'Bulawayo', name: 'Bulawayo' },
        { value: 'Harare', name: 'Harare' },
        { value: 'Manicaland', name: 'Manicaland' },
        { value: 'Mashonaland Central', name: 'Mashonaland Central' },
        { value: 'Mashonaland East', name: 'Mashonaland East' },
        { value: 'Mashonaland West', name: 'Mashonaland West' },
        { value: 'Masvingo', name: 'Masvingo' },
        { value: 'Matabeleland North', name: 'Matabeleland North' },
        { value: 'Matabeleland South', name: 'Matabeleland South' },
        { value: 'Midlands', name: 'Midlands' },
    ],
}
